{
  "asOf": "2026-07-14",
  "history": [
    {
      "schemaVersion": 2,
      "date": "2026-07-14",
      "capturedAt": "2026-07-14T10:19:52.000Z",
      "currency": "USD",
      "rentalType": "on-demand",
      "sample": {
        "vastQueryLimit": 5000,
        "vastOfferCount": 1182,
        "vastCatalogOfferCount": 391,
        "vastSampleTruncated": false,
        "vastReliabilityFloor": 0.95,
        "runpodGpuTypeCount": 49,
        "azureCpuSkuCount": 10,
        "azureCpuRegion": "eastus"
      },
      "rows": [
        {
          "sku": "b300",
          "label": "B300",
          "segment": "frontier",
          "vramGb": 288,
          "vast": {
            "offerCount": 1,
            "gpuCount": 8,
            "pricePerGpuHourUsd": {
              "min": 7.813194444444443,
              "p25": 7.813194444444443,
              "median": 7.813194444444443,
              "p75": 7.813194444444443
            },
            "medianEffectiveVcpuPerGpu": 24,
            "medianCpuRamGbPerGpu": 251.4044189453125,
            "medianBundleUsdPerEffectiveVcpuHour": 0.32554976851851847,
            "medianDlperfPerDollar": 103.02077584342038,
            "medianFlopsPerDollar": 8.522068210825706,
            "medianReliabilityPct": 98.91963
          },
          "runpodCommunity": null,
          "runpodSecure": null
        },
        {
          "sku": "b200",
          "label": "B200",
          "segment": "frontier",
          "vramGb": 180,
          "vast": {
            "offerCount": 7,
            "gpuCount": 12,
            "pricePerGpuHourUsd": {
              "min": 6.252083333333333,
              "p25": 6.8765625,
              "median": 7.539583333333333,
              "p75": 8.753645833333334
            },
            "medianEffectiveVcpuPerGpu": 24,
            "medianCpuRamGbPerGpu": 249.5009765625,
            "medianBundleUsdPerEffectiveVcpuHour": 0.28998397435897433,
            "medianDlperfPerDollar": 75.98734141353773,
            "medianFlopsPerDollar": 7.899632296214424,
            "medianReliabilityPct": 99.57184
          },
          "runpodCommunity": null,
          "runpodSecure": null
        },
        {
          "sku": "mi300x",
          "label": "MI300X",
          "segment": "frontier",
          "vramGb": 192,
          "vast": null,
          "runpodCommunity": null,
          "runpodSecure": null
        },
        {
          "sku": "h200-sxm",
          "label": "H200 SXM",
          "segment": "frontier",
          "vramGb": 141,
          "vast": {
            "offerCount": 11,
            "gpuCount": 19,
            "pricePerGpuHourUsd": {
              "min": 3.2907894736842103,
              "p25": 3.52758552631579,
              "median": 3.6845877192982455,
              "p75": 3.7510964912280707
            },
            "medianEffectiveVcpuPerGpu": 28,
            "medianCpuRamGbPerGpu": 251.9169921875,
            "medianBundleUsdPerEffectiveVcpuHour": 0.1339546783625731,
            "medianDlperfPerDollar": 133.83469361139888,
            "medianFlopsPerDollar": 14.527141725966153,
            "medianReliabilityPct": 99.751
          },
          "runpodCommunity": null,
          "runpodSecure": {
            "stockStatus": "High",
            "pricePerGpuHourUsd": 4.39,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "h200-nvl",
          "label": "H200 NVL",
          "segment": "frontier",
          "vramGb": 143,
          "vast": {
            "offerCount": 6,
            "gpuCount": 11,
            "pricePerGpuHourUsd": {
              "min": 3.211111111111111,
              "p25": 3.4818055555555554,
              "median": 3.4827777777777778,
              "p75": 3.7231666666666667
            },
            "medianEffectiveVcpuPerGpu": 28,
            "medianCpuRamGbPerGpu": 251.908203125,
            "medianBundleUsdPerEffectiveVcpuHour": 0.12270833333333334,
            "medianDlperfPerDollar": 117.46254617830375,
            "medianFlopsPerDollar": 13.855313289221778,
            "medianReliabilityPct": 99.82071
          },
          "runpodCommunity": null,
          "runpodSecure": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 3.79,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "h100-sxm",
          "label": "H100 SXM",
          "segment": "frontier",
          "vramGb": 80,
          "vast": {
            "offerCount": 25,
            "gpuCount": 45,
            "pricePerGpuHourUsd": {
              "min": 1.733888888888889,
              "p25": 1.7355555555555555,
              "median": 2.136296296296296,
              "p75": 2.8022222222222224
            },
            "medianEffectiveVcpuPerGpu": 26,
            "medianCpuRamGbPerGpu": 188.693359375,
            "medianBundleUsdPerEffectiveVcpuHour": 0.10231623931623933,
            "medianDlperfPerDollar": 132.46977727496105,
            "medianFlopsPerDollar": 25.055760332871017,
            "medianReliabilityPct": 99.77436
          },
          "runpodCommunity": null,
          "runpodSecure": {
            "stockStatus": "High",
            "pricePerGpuHourUsd": 2.99,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "h100-nvl",
          "label": "H100 NVL",
          "segment": "frontier",
          "vramGb": 94,
          "vast": {
            "offerCount": 5,
            "gpuCount": 10,
            "pricePerGpuHourUsd": {
              "min": 2.0007407407407407,
              "p25": 2.0014814814814814,
              "median": 2.1128888888888886,
              "p75": 2.800555555555556
            },
            "medianEffectiveVcpuPerGpu": 32,
            "medianCpuRamGbPerGpu": 188.6865234375,
            "medianBundleUsdPerEffectiveVcpuHour": 0.08751736111111112,
            "medianDlperfPerDollar": 145.5954404812936,
            "medianFlopsPerDollar": 22.838387883887254,
            "medianReliabilityPct": 99.80109999999999
          },
          "runpodCommunity": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 2.59,
            "availableGpuCounts": null
          },
          "runpodSecure": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 3.19,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "h100-pcie",
          "label": "H100 PCIe",
          "segment": "frontier",
          "vramGb": 80,
          "vast": {
            "offerCount": 6,
            "gpuCount": 18,
            "pricePerGpuHourUsd": {
              "min": 1.7336111111111117,
              "p25": 1.7369444444444444,
              "median": 1.8058333333333332,
              "p75": 1.868472222222222
            },
            "medianEffectiveVcpuPerGpu": 24,
            "medianCpuRamGbPerGpu": 188.94287109375,
            "medianBundleUsdPerEffectiveVcpuHour": 0.07503472222222222,
            "medianDlperfPerDollar": 129.98545267533325,
            "medianFlopsPerDollar": 22.716239527438184,
            "medianReliabilityPct": 98.36310999999999
          },
          "runpodCommunity": null,
          "runpodSecure": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 2.89,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "a100-sxm-80",
          "label": "A100 SXM 80GB",
          "segment": "inference",
          "vramGb": 80,
          "vast": {
            "offerCount": 10,
            "gpuCount": 23,
            "pricePerGpuHourUsd": {
              "min": 1.0022222222222221,
              "p25": 1.0356851851851852,
              "median": 1.0617407407407407,
              "p75": 1.069
            },
            "medianEffectiveVcpuPerGpu": 32,
            "medianCpuRamGbPerGpu": 125.8963623046875,
            "medianBundleUsdPerEffectiveVcpuHour": 0.03339583333333333,
            "medianDlperfPerDollar": 114.47214833932597,
            "medianFlopsPerDollar": 14.68711151336278,
            "medianReliabilityPct": 98.900865
          },
          "runpodCommunity": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 1.39,
            "availableGpuCounts": null
          },
          "runpodSecure": {
            "stockStatus": "High",
            "pricePerGpuHourUsd": 1.49,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "a100-pcie-80",
          "label": "A100 PCIe 80GB",
          "segment": "inference",
          "vramGb": 80,
          "vast": {
            "offerCount": 7,
            "gpuCount": 13,
            "pricePerGpuHourUsd": {
              "min": 1.001111111111111,
              "p25": 1.0016666666666665,
              "median": 1.0022222222222221,
              "p75": 1.396087037037037
            },
            "medianEffectiveVcpuPerGpu": 16,
            "medianCpuRamGbPerGpu": 125.87255859375,
            "medianBundleUsdPerEffectiveVcpuHour": 0.06263888888888888,
            "medianDlperfPerDollar": 91.44572355094135,
            "medianFlopsPerDollar": 15.55889667405765,
            "medianReliabilityPct": 99.71306
          },
          "runpodCommunity": null,
          "runpodSecure": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 1.39,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "a100-40",
          "label": "A100 40GB",
          "segment": "inference",
          "vramGb": 40,
          "vast": {
            "offerCount": 30,
            "gpuCount": 47,
            "pricePerGpuHourUsd": {
              "min": 0.374962962962963,
              "p25": 0.6938592592592593,
              "median": 0.7366474074074074,
              "p75": 0.8488407407407407
            },
            "medianEffectiveVcpuPerGpu": 16,
            "medianCpuRamGbPerGpu": 83.931884765625,
            "medianBundleUsdPerEffectiveVcpuHour": 0.046039861111111115,
            "medianDlperfPerDollar": 122.97012503609068,
            "medianFlopsPerDollar": 21.168208969989898,
            "medianReliabilityPct": 99.549015
          },
          "runpodCommunity": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 1,
            "availableGpuCounts": null
          },
          "runpodSecure": null
        },
        {
          "sku": "l40s",
          "label": "L40S",
          "segment": "inference",
          "vramGb": 48,
          "vast": {
            "offerCount": 9,
            "gpuCount": 25,
            "pricePerGpuHourUsd": {
              "min": 0.46685185185185185,
              "p25": 0.6674074074074073,
              "median": 0.8007407407407406,
              "p75": 0.8014814814814815
            },
            "medianEffectiveVcpuPerGpu": 24,
            "medianCpuRamGbPerGpu": 251.9384765625,
            "medianBundleUsdPerEffectiveVcpuHour": 0.03336419753086419,
            "medianDlperfPerDollar": 116.74258889280097,
            "medianFlopsPerDollar": 91.52229713228495,
            "medianReliabilityPct": 99.67712
          },
          "runpodCommunity": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 0.79,
            "availableGpuCounts": null
          },
          "runpodSecure": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 0.99,
            "availableGpuCounts": null
          }
        },
        {
          "sku": "rtx-5090",
          "label": "RTX 5090",
          "segment": "consumer",
          "vramGb": 32,
          "vast": {
            "offerCount": 147,
            "gpuCount": 488,
            "pricePerGpuHourUsd": {
              "min": 0.3114814814814815,
              "p25": 0.42720370370370375,
              "median": 0.5088888888888888,
              "p75": 0.6408333333333334
            },
            "medianEffectiveVcpuPerGpu": 32,
            "medianCpuRamGbPerGpu": 62.9566650390625,
            "medianBundleUsdPerEffectiveVcpuHour": 0.018796296296296297,
            "medianDlperfPerDollar": 284.4293050048267,
            "medianFlopsPerDollar": 212.43081222707426,
            "medianReliabilityPct": 99.42704
          },
          "runpodCommunity": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 0.69,
            "availableGpuCounts": null
          },
          "runpodSecure": null
        },
        {
          "sku": "rtx-4090",
          "label": "RTX 4090",
          "segment": "consumer",
          "vramGb": 24,
          "vast": {
            "offerCount": 127,
            "gpuCount": 364,
            "pricePerGpuHourUsd": {
              "min": 0.2677407407407407,
              "p25": 0.36111111111111116,
              "median": 0.3874074074074074,
              "p75": 0.46194444444444444
            },
            "medianEffectiveVcpuPerGpu": 16,
            "medianCpuRamGbPerGpu": 62.9560546875,
            "medianBundleUsdPerEffectiveVcpuHour": 0.024186921296296293,
            "medianDlperfPerDollar": 212.65538904353318,
            "medianFlopsPerDollar": 210.2041342898135,
            "medianReliabilityPct": 99.5915
          },
          "runpodCommunity": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 0.34,
            "availableGpuCounts": null
          },
          "runpodSecure": {
            "stockStatus": "Low",
            "pricePerGpuHourUsd": 0.69,
            "availableGpuCounts": null
          }
        }
      ],
      "cpuRows": [
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "general",
          "sku": "Standard_D2as_v5",
          "label": "D2as v5",
          "vcpus": 2,
          "memoryGb": 8,
          "pricePerHourUsd": 0.086,
          "pricePerVcpuHourUsd": 0.043,
          "pricePerMemoryGbHourUsd": 0.01075,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "general",
          "sku": "Standard_D4as_v5",
          "label": "D4as v5",
          "vcpus": 4,
          "memoryGb": 16,
          "pricePerHourUsd": 0.172,
          "pricePerVcpuHourUsd": 0.043,
          "pricePerMemoryGbHourUsd": 0.01075,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "general",
          "sku": "Standard_D8as_v5",
          "label": "D8as v5",
          "vcpus": 8,
          "memoryGb": 32,
          "pricePerHourUsd": 0.344,
          "pricePerVcpuHourUsd": 0.043,
          "pricePerMemoryGbHourUsd": 0.01075,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "general",
          "sku": "Standard_D16as_v5",
          "label": "D16as v5",
          "vcpus": 16,
          "memoryGb": 64,
          "pricePerHourUsd": 0.688,
          "pricePerVcpuHourUsd": 0.043,
          "pricePerMemoryGbHourUsd": 0.01075,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "general",
          "sku": "Standard_D32as_v5",
          "label": "D32as v5",
          "vcpus": 32,
          "memoryGb": 128,
          "pricePerHourUsd": 1.376,
          "pricePerVcpuHourUsd": 0.043,
          "pricePerMemoryGbHourUsd": 0.01075,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "memory",
          "sku": "Standard_E2as_v5",
          "label": "E2as v5",
          "vcpus": 2,
          "memoryGb": 16,
          "pricePerHourUsd": 0.113,
          "pricePerVcpuHourUsd": 0.0565,
          "pricePerMemoryGbHourUsd": 0.0070625,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "memory",
          "sku": "Standard_E4as_v5",
          "label": "E4as v5",
          "vcpus": 4,
          "memoryGb": 32,
          "pricePerHourUsd": 0.226,
          "pricePerVcpuHourUsd": 0.0565,
          "pricePerMemoryGbHourUsd": 0.0070625,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "memory",
          "sku": "Standard_E8as_v5",
          "label": "E8as v5",
          "vcpus": 8,
          "memoryGb": 64,
          "pricePerHourUsd": 0.452,
          "pricePerVcpuHourUsd": 0.0565,
          "pricePerMemoryGbHourUsd": 0.0070625,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "memory",
          "sku": "Standard_E16as_v5",
          "label": "E16as v5",
          "vcpus": 16,
          "memoryGb": 128,
          "pricePerHourUsd": 0.904,
          "pricePerVcpuHourUsd": 0.0565,
          "pricePerMemoryGbHourUsd": 0.0070625,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        },
        {
          "provider": "azure",
          "region": "eastus",
          "tier": "memory",
          "sku": "Standard_E32as_v5",
          "label": "E32as v5",
          "vcpus": 32,
          "memoryGb": 256,
          "pricePerHourUsd": 1.808,
          "pricePerVcpuHourUsd": 0.0565,
          "pricePerMemoryGbHourUsd": 0.0070625,
          "effectiveStartDate": "2021-12-01T00:00:00.000Z"
        }
      ]
    }
  ],
  "gpuPriceHistory": {
    "source": "getflops",
    "sourceUrl": "https://www.getflops.ai/api/history_all",
    "attribution": "Historical GPU pricing: getflops.ai",
    "firstDate": "2026-03-14",
    "lastDate": "2026-07-14",
    "series": [
      {
        "sku": "b200",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T06:12:38.155Z",
            "minPricePerGpuHourUsd": 3.7502,
            "medianPricePerGpuHourUsd": 3.7502,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 3.127,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 3.127,
            "medianPricePerGpuHourUsd": 3.6261,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 3.1263,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 3.1263,
            "medianPricePerGpuHourUsd": 3.1263,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 3.127,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 3.001,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 3.001,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 3.001,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 2.3139,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 3.001,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 5.0014,
            "medianPricePerGpuHourUsd": 5.6271,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 3.001,
            "medianPricePerGpuHourUsd": 4.5014,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.127,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 4.0642,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 3.1885,
            "medianPricePerGpuHourUsd": 5.0001,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 3.1896,
            "medianPricePerGpuHourUsd": 3.8139,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 3.188,
            "medianPricePerGpuHourUsd": 3.8139,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 24
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 3.0017,
            "medianPricePerGpuHourUsd": 3.8139,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 4.3752,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 3.1896,
            "medianPricePerGpuHourUsd": 4.7514,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 3.1896,
            "medianPricePerGpuHourUsd": 4.3752,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.8132,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.8135,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 3.0017,
            "medianPricePerGpuHourUsd": 3.8139,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.8132,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 22
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 3.8128,
            "medianPricePerGpuHourUsd": 3.8139,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 3.0017,
            "medianPricePerGpuHourUsd": 4.0503,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 27
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.8139,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 20
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.8627,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.851,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 4.1889,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 21
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 3.126,
            "medianPricePerGpuHourUsd": 3.8014,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 3.1254,
            "medianPricePerGpuHourUsd": 3.8135,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 3.1254,
            "medianPricePerGpuHourUsd": 3.9385,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 3.7502,
            "medianPricePerGpuHourUsd": 4.5321,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 3.251,
            "medianPricePerGpuHourUsd": 4.0632,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 3.4396,
            "medianPricePerGpuHourUsd": 3.9377,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 3.0017,
            "medianPricePerGpuHourUsd": 4.4705,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 3.6253,
            "medianPricePerGpuHourUsd": 4.0635,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 3.6253,
            "medianPricePerGpuHourUsd": 3.9396,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 3.6878,
            "medianPricePerGpuHourUsd": 3.8132,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 3.6253,
            "medianPricePerGpuHourUsd": 4.5317,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 22
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 3.6878,
            "medianPricePerGpuHourUsd": 3.9396,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 3.6253,
            "medianPricePerGpuHourUsd": 3.8767,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T01:49:52.039Z",
            "minPricePerGpuHourUsd": 3.7627,
            "medianPricePerGpuHourUsd": 3.8073,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 3.9382,
            "medianPricePerGpuHourUsd": 4.0014,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T01:49:51.866Z",
            "minPricePerGpuHourUsd": 3.8003,
            "medianPricePerGpuHourUsd": 4.0635,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 3.9385,
            "medianPricePerGpuHourUsd": 5.8757,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 3.7502,
            "medianPricePerGpuHourUsd": 5.9315,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 3.7502,
            "medianPricePerGpuHourUsd": 4.6828,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 3.626,
            "medianPricePerGpuHourUsd": 4.6813,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 23
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 1.065,
            "medianPricePerGpuHourUsd": 5.6278,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 3.7502,
            "medianPricePerGpuHourUsd": 6.238,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 3.7502,
            "medianPricePerGpuHourUsd": 6.238,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 3.6878,
            "medianPricePerGpuHourUsd": 3.9396,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 3.9396,
            "medianPricePerGpuHourUsd": 5.3792,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 3.8132,
            "medianPricePerGpuHourUsd": 5.4722,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T01:49:52.056Z",
            "minPricePerGpuHourUsd": 3.8128,
            "medianPricePerGpuHourUsd": 5.3806,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 3.938,
            "medianPricePerGpuHourUsd": 5.001,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T01:49:50.643Z",
            "minPricePerGpuHourUsd": 3.8132,
            "medianPricePerGpuHourUsd": 5.1896,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 3.9385,
            "medianPricePerGpuHourUsd": 5.0005,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 3.8128,
            "medianPricePerGpuHourUsd": 5.0003,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 3.8003,
            "medianPricePerGpuHourUsd": 3.8767,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 3.8978,
            "medianPricePerGpuHourUsd": 3.9047,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 3.9106,
            "medianPricePerGpuHourUsd": 4.6171,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 3.9116,
            "medianPricePerGpuHourUsd": 8.2076,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 3.7822,
            "medianPricePerGpuHourUsd": 4.6171,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 3.8981,
            "medianPricePerGpuHourUsd": 4.6171,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 3.7822,
            "medianPricePerGpuHourUsd": 4.2329,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 23
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 3.7183,
            "medianPricePerGpuHourUsd": 7.3089,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 21
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 4.6171,
            "medianPricePerGpuHourUsd": 6.1613,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 4.6163,
            "medianPricePerGpuHourUsd": 6.0356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 6.0269,
            "medianPricePerGpuHourUsd": 7.2319,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 4.2318,
            "medianPricePerGpuHourUsd": 6.3992,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 4.4874,
            "medianPricePerGpuHourUsd": 6.3992,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 30
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 4.4882,
            "medianPricePerGpuHourUsd": 6.3992,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 33
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 4.5009,
            "medianPricePerGpuHourUsd": 6.2393,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 4.3761,
            "medianPricePerGpuHourUsd": 6.2384,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 30
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 4.3755,
            "medianPricePerGpuHourUsd": 6.2402,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 28
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 4.3761,
            "medianPricePerGpuHourUsd": 6.2384,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 42
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 4.2524,
            "medianPricePerGpuHourUsd": 6.2384,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 4.1887,
            "medianPricePerGpuHourUsd": 4.5759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 42
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 4.1887,
            "medianPricePerGpuHourUsd": 4.5759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 43
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 4.3753,
            "medianPricePerGpuHourUsd": 4.9911,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 36
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 3.4384,
            "medianPricePerGpuHourUsd": 4.0694,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 45
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 3.4384,
            "medianPricePerGpuHourUsd": 4.3757,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 44
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 3.4384,
            "medianPricePerGpuHourUsd": 4.3759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 3.4384,
            "medianPricePerGpuHourUsd": 4.3766,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 36
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 3.4384,
            "medianPricePerGpuHourUsd": 4.3761,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 38
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 3.4384,
            "medianPricePerGpuHourUsd": 4.066,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 3.9774,
            "medianPricePerGpuHourUsd": 4.1948,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 3.1021,
            "medianPricePerGpuHourUsd": 4.1936,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 3.9774,
            "medianPricePerGpuHourUsd": 4.3771,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 3.9774,
            "medianPricePerGpuHourUsd": 4.2896,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 33
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 3.9774,
            "medianPricePerGpuHourUsd": 4.3755,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 29
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 3.9514,
            "medianPricePerGpuHourUsd": 4.3755,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 31
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 4.0694,
            "medianPricePerGpuHourUsd": 4.2143,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 4.0634,
            "medianPricePerGpuHourUsd": 4.1292,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 4.0642,
            "medianPricePerGpuHourUsd": 4.3184,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 4.2896,
            "medianPricePerGpuHourUsd": 4.3498,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 4.3424,
            "medianPricePerGpuHourUsd": 4.5024,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 4.0642,
            "medianPricePerGpuHourUsd": 4.3759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 4.0642,
            "medianPricePerGpuHourUsd": 4.3424,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 4.1637,
            "medianPricePerGpuHourUsd": 4.3561,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 5.0003,
            "medianPricePerGpuHourUsd": 5.4398,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 5.001,
            "medianPricePerGpuHourUsd": 5.4024,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 4.9762,
            "medianPricePerGpuHourUsd": 5.0016,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 4.6896,
            "medianPricePerGpuHourUsd": 5.0955,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 4.6896,
            "medianPricePerGpuHourUsd": 5.8774,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 5.001,
            "medianPricePerGpuHourUsd": 5.8774,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 5.0021,
            "medianPricePerGpuHourUsd": 5.8774,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 5.0021,
            "medianPricePerGpuHourUsd": 6.2536,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 5.001,
            "medianPricePerGpuHourUsd": 5.7523,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 8.1299,
            "medianPricePerGpuHourUsd": 8.1323,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 8.1299,
            "medianPricePerGpuHourUsd": 8.1323,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 5.001,
            "medianPricePerGpuHourUsd": 6.5679,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 5.0021,
            "medianPricePerGpuHourUsd": 8.1299,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 7.5024,
            "medianPricePerGpuHourUsd": 8.1311,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          }
        ]
      },
      {
        "sku": "b200",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 5.98,
            "medianPricePerGpuHourUsd": 5.98,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "b200",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 4.99,
            "medianPricePerGpuHourUsd": 4.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 5.49,
            "medianPricePerGpuHourUsd": 5.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 5.89,
            "medianPricePerGpuHourUsd": 5.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h200-sxm",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 1.9885,
            "medianPricePerGpuHourUsd": 2.3256,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.6461,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 1.9368,
            "medianPricePerGpuHourUsd": 2.5516,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.8409,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.9685,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 2.3228,
            "medianPricePerGpuHourUsd": 2.9688,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.714,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 2.3237,
            "medianPricePerGpuHourUsd": 2.9679,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 1.9885,
            "medianPricePerGpuHourUsd": 2.5849,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T01:49:52.058Z",
            "minPricePerGpuHourUsd": 2.3229,
            "medianPricePerGpuHourUsd": 2.5849,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 2.3229,
            "medianPricePerGpuHourUsd": 2.8409,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 2.3228,
            "medianPricePerGpuHourUsd": 2.3237,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 2.0695,
            "medianPricePerGpuHourUsd": 2.5817,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 2.3229,
            "medianPricePerGpuHourUsd": 2.452,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 2.067,
            "medianPricePerGpuHourUsd": 2.3237,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.3242,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 22
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 2.0695,
            "medianPricePerGpuHourUsd": 2.3333,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.3237,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.3237,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 2.0667,
            "medianPricePerGpuHourUsd": 2.4563,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 2.0667,
            "medianPricePerGpuHourUsd": 2.9055,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 2.0667,
            "medianPricePerGpuHourUsd": 2.4905,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 2.0667,
            "medianPricePerGpuHourUsd": 2.5817,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 2.3231,
            "medianPricePerGpuHourUsd": 2.5849,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 2.3231,
            "medianPricePerGpuHourUsd": 2.3234,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 2.0695,
            "medianPricePerGpuHourUsd": 2.4575,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 2.3237,
            "medianPricePerGpuHourUsd": 2.5829,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 2.3333,
            "medianPricePerGpuHourUsd": 2.843,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 2.3333,
            "medianPricePerGpuHourUsd": 2.8391,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 2.5821,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 2.3237,
            "medianPricePerGpuHourUsd": 2.9035,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 2.0695,
            "medianPricePerGpuHourUsd": 2.71,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 2.3333,
            "medianPricePerGpuHourUsd": 3.4842,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 1.9885,
            "medianPricePerGpuHourUsd": 3.3556,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 1.9885,
            "medianPricePerGpuHourUsd": 3.614,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 1.9892,
            "medianPricePerGpuHourUsd": 3.1847,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 2.3237,
            "medianPricePerGpuHourUsd": 2.5829,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 1.9885,
            "medianPricePerGpuHourUsd": 3.2264,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 1.9361,
            "medianPricePerGpuHourUsd": 2.7429,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 20
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 2.328,
            "medianPricePerGpuHourUsd": 3.3647,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 1.9882,
            "medianPricePerGpuHourUsd": 3.2264,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 1.9361,
            "medianPricePerGpuHourUsd": 2.3231,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.9368,
            "medianPricePerGpuHourUsd": 3.4877,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 3.3632,
            "medianPricePerGpuHourUsd": 3.7746,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 1.9368,
            "medianPricePerGpuHourUsd": 3.3632,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 1.9368,
            "medianPricePerGpuHourUsd": 3.6818,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 1.9885,
            "medianPricePerGpuHourUsd": 3.3565,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 2.5808,
            "medianPricePerGpuHourUsd": 3.5235,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 2.3333,
            "medianPricePerGpuHourUsd": 3.8079,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T01:49:52.039Z",
            "minPricePerGpuHourUsd": 3.4844,
            "medianPricePerGpuHourUsd": 3.4849,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 3.2909,
            "medianPricePerGpuHourUsd": 3.328,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T01:49:51.866Z",
            "minPricePerGpuHourUsd": 3.3599,
            "medianPricePerGpuHourUsd": 3.5834,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 3.3651,
            "medianPricePerGpuHourUsd": 3.916,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 3.3651,
            "medianPricePerGpuHourUsd": 3.4877,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 3.8068,
            "medianPricePerGpuHourUsd": 4.1941,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 3.228,
            "medianPricePerGpuHourUsd": 3.7442,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 1.228,
            "medianPricePerGpuHourUsd": 3.614,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 3.3632,
            "medianPricePerGpuHourUsd": 3.9851,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 3.1075,
            "medianPricePerGpuHourUsd": 3.872,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 3.8715,
            "medianPricePerGpuHourUsd": 4.0016,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 3.1022,
            "medianPricePerGpuHourUsd": 3.2919,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 3.4844,
            "medianPricePerGpuHourUsd": 3.4849,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T01:49:52.056Z",
            "minPricePerGpuHourUsd": 3.8715,
            "medianPricePerGpuHourUsd": 3.8718,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T01:49:50.643Z",
            "minPricePerGpuHourUsd": 4.2595,
            "medianPricePerGpuHourUsd": 4.2849,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 3.8397,
            "medianPricePerGpuHourUsd": 3.872,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 3.8715,
            "medianPricePerGpuHourUsd": 3.8726,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 3.3618,
            "medianPricePerGpuHourUsd": 3.8734,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 3.915,
            "medianPricePerGpuHourUsd": 3.9495,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 3.9501,
            "medianPricePerGpuHourUsd": 4.3432,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 3.4296,
            "medianPricePerGpuHourUsd": 4.0795,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 3.2242,
            "medianPricePerGpuHourUsd": 3.9495,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 27
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 3.4296,
            "medianPricePerGpuHourUsd": 4.0795,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 27
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 3.5992,
            "medianPricePerGpuHourUsd": 4.0467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 40
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 3.5174,
            "medianPricePerGpuHourUsd": 3.9484,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 31
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 3.5599,
            "medianPricePerGpuHourUsd": 3.9484,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 36
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 3.6848,
            "medianPricePerGpuHourUsd": 3.9554,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 24
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 3.9476,
            "medianPricePerGpuHourUsd": 3.9484,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 3.5042,
            "medianPricePerGpuHourUsd": 4.0143,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 3.6864,
            "medianPricePerGpuHourUsd": 4.1891,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 28
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 3.6864,
            "medianPricePerGpuHourUsd": 4.2109,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 27
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 3.8161,
            "medianPricePerGpuHourUsd": 3.9486,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 36
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 3.6864,
            "medianPricePerGpuHourUsd": 4.0792,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 3.4281,
            "medianPricePerGpuHourUsd": 3.9479,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 29
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 3.5528,
            "medianPricePerGpuHourUsd": 3.8163,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 39
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 3.1637,
            "medianPricePerGpuHourUsd": 3.8034,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 3.0611,
            "medianPricePerGpuHourUsd": 3.8174,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 44
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 3.1729,
            "medianPricePerGpuHourUsd": 3.803,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 45
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 3.2113,
            "medianPricePerGpuHourUsd": 3.8161,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 45
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 3.2109,
            "medianPricePerGpuHourUsd": 3.7511,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 44
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 3.1951,
            "medianPricePerGpuHourUsd": 3.7183,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 46
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 2.6419,
            "medianPricePerGpuHourUsd": 3.6189,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 42
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 2.7642,
            "medianPricePerGpuHourUsd": 3.5543,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 46
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 2.7653,
            "medianPricePerGpuHourUsd": 3.6845,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 43
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 3.2107,
            "medianPricePerGpuHourUsd": 3.4885,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 2.8297,
            "medianPricePerGpuHourUsd": 3.7181,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 2.7767,
            "medianPricePerGpuHourUsd": 3.5084,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 2.8297,
            "medianPricePerGpuHourUsd": 3.6845,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 31
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 2.7653,
            "medianPricePerGpuHourUsd": 3.6845,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 32
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 2.7642,
            "medianPricePerGpuHourUsd": 3.6845,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 27
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 2.8142,
            "medianPricePerGpuHourUsd": 3.6845,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 24
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 2.9754,
            "medianPricePerGpuHourUsd": 3.5087,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 3.212,
            "medianPricePerGpuHourUsd": 3.6191,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 3.2113,
            "medianPricePerGpuHourUsd": 3.6188,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 2.6462,
            "medianPricePerGpuHourUsd": 3.4653,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 3.0504,
            "medianPricePerGpuHourUsd": 3.7511,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 3.0278,
            "medianPricePerGpuHourUsd": 3.2905,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 2.7899,
            "medianPricePerGpuHourUsd": 3.3692,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 2.7634,
            "medianPricePerGpuHourUsd": 3.5537,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 3.0278,
            "medianPricePerGpuHourUsd": 3.5009,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 3.0278,
            "medianPricePerGpuHourUsd": 4.0792,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 3.0267,
            "medianPricePerGpuHourUsd": 4.0811,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 3.0267,
            "medianPricePerGpuHourUsd": 3.2901,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 3.5307,
            "medianPricePerGpuHourUsd": 4.08,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 3.1649,
            "medianPricePerGpuHourUsd": 3.6759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 3.0278,
            "medianPricePerGpuHourUsd": 3.7505,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 3.027,
            "medianPricePerGpuHourUsd": 4.0467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 3.4116,
            "medianPricePerGpuHourUsd": 3.748,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 3.4111,
            "medianPricePerGpuHourUsd": 3.7515,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 3.7035,
            "medianPricePerGpuHourUsd": 3.706,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 3.1403,
            "medianPricePerGpuHourUsd": 4.0795,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 3.2537,
            "medianPricePerGpuHourUsd": 3.6691,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 3.707,
            "medianPricePerGpuHourUsd": 3.9154,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          }
        ]
      },
      {
        "sku": "h200-sxm",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h200-sxm",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 3.59,
            "medianPricePerGpuHourUsd": 3.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 3.99,
            "medianPricePerGpuHourUsd": 3.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 4.39,
            "medianPricePerGpuHourUsd": 4.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h200-nvl",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 2.0687,
            "medianPricePerGpuHourUsd": 2.1958,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 1.9024,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 2.1356,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 2.2267,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 2.0719,
            "medianPricePerGpuHourUsd": 2.5777,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 2.7636,
            "medianPricePerGpuHourUsd": 2.7636,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 2.0052,
            "medianPricePerGpuHourUsd": 2.2693,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 2.2381,
            "medianPricePerGpuHourUsd": 2.2644,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 1.9396,
            "medianPricePerGpuHourUsd": 2.2645,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 3.2061,
            "medianPricePerGpuHourUsd": 3.2061,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 2.1156,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 3.2052,
            "medianPricePerGpuHourUsd": 3.2052,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 2.2267,
            "medianPricePerGpuHourUsd": 2.4164,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 2.3247,
            "medianPricePerGpuHourUsd": 2.3906,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 2.2833,
            "medianPricePerGpuHourUsd": 2.2867,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 2.2217,
            "medianPricePerGpuHourUsd": 2.255,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 2.2233,
            "medianPricePerGpuHourUsd": 2.2833,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 2.2867,
            "medianPricePerGpuHourUsd": 2.349,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 2.2233,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 2.2233,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 2.2267,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 2.2267,
            "medianPricePerGpuHourUsd": 2.2267,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 2.2267,
            "medianPricePerGpuHourUsd": 2.6358,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 2.2233,
            "medianPricePerGpuHourUsd": 2.225,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 2.3633,
            "medianPricePerGpuHourUsd": 2.7962,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 2.1371,
            "medianPricePerGpuHourUsd": 2.3667,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 1.8171,
            "medianPricePerGpuHourUsd": 2.045,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 2.4447,
            "medianPricePerGpuHourUsd": 2.6901,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 2.0939,
            "medianPricePerGpuHourUsd": 2.2507,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 1.6451,
            "medianPricePerGpuHourUsd": 1.6451,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 2.1742,
            "medianPricePerGpuHourUsd": 2.299,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 2.0051,
            "medianPricePerGpuHourUsd": 2.177,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 2.1742,
            "medianPricePerGpuHourUsd": 2.7151,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 1.9233,
            "medianPricePerGpuHourUsd": 2.709,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 2.1787,
            "medianPricePerGpuHourUsd": 2.5156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 2.1598,
            "medianPricePerGpuHourUsd": 2.9339,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 2.0827,
            "medianPricePerGpuHourUsd": 2.679,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 2.2867,
            "medianPricePerGpuHourUsd": 2.4497,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 2.5222,
            "medianPricePerGpuHourUsd": 2.5994,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 2.4388,
            "medianPricePerGpuHourUsd": 2.6467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 2.9356,
            "medianPricePerGpuHourUsd": 2.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 2.5585,
            "medianPricePerGpuHourUsd": 2.7866,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 2.9356,
            "medianPricePerGpuHourUsd": 3.0025,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 3.0067,
            "medianPricePerGpuHourUsd": 3.2542,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 3.6724,
            "medianPricePerGpuHourUsd": 3.6724,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 3.0022,
            "medianPricePerGpuHourUsd": 3.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 4.3598,
            "medianPricePerGpuHourUsd": 4.3603,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 3.0022,
            "medianPricePerGpuHourUsd": 3.5216,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 3.5726,
            "medianPricePerGpuHourUsd": 3.5726,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 3.1391,
            "medianPricePerGpuHourUsd": 3.9725,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 4.2022,
            "medianPricePerGpuHourUsd": 4.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 3.6726,
            "medianPricePerGpuHourUsd": 4.1031,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 4.4542,
            "medianPricePerGpuHourUsd": 4.9002,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 4.4531,
            "medianPricePerGpuHourUsd": 5.1811,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 4.2464,
            "medianPricePerGpuHourUsd": 4.5851,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 3.936,
            "medianPricePerGpuHourUsd": 4.1017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 3.657,
            "medianPricePerGpuHourUsd": 4.0651,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 3.7462,
            "medianPricePerGpuHourUsd": 4.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 3.7797,
            "medianPricePerGpuHourUsd": 4.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 4.0011,
            "medianPricePerGpuHourUsd": 4.0017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 4.0011,
            "medianPricePerGpuHourUsd": 4.0017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 3.7218,
            "medianPricePerGpuHourUsd": 4.1684,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 3.4678,
            "medianPricePerGpuHourUsd": 4.0017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 3.4578,
            "medianPricePerGpuHourUsd": 4.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 3.504,
            "medianPricePerGpuHourUsd": 4.0017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 3.5904,
            "medianPricePerGpuHourUsd": 4.2678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 3.534,
            "medianPricePerGpuHourUsd": 4.0008,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 3.6329,
            "medianPricePerGpuHourUsd": 4.2798,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 3.6578,
            "medianPricePerGpuHourUsd": 4.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 3.0022,
            "medianPricePerGpuHourUsd": 3.7344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 3.0011,
            "medianPricePerGpuHourUsd": 3.6894,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 3.0022,
            "medianPricePerGpuHourUsd": 3.6033,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 3.3339,
            "medianPricePerGpuHourUsd": 3.6067,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 3.3344,
            "medianPricePerGpuHourUsd": 3.9357,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 3.0358,
            "medianPricePerGpuHourUsd": 3.3104,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 2.5348,
            "medianPricePerGpuHourUsd": 3.2027,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 3.2733,
            "medianPricePerGpuHourUsd": 3.2733,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 2.6733,
            "medianPricePerGpuHourUsd": 2.7378,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 2.9344,
            "medianPricePerGpuHourUsd": 3.0984,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 2.6678,
            "medianPricePerGpuHourUsd": 3.0028,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 2.4111,
            "medianPricePerGpuHourUsd": 2.9711,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 2.6689,
            "medianPricePerGpuHourUsd": 3.4637,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 2.4251,
            "medianPricePerGpuHourUsd": 2.6809,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 3.3247,
            "medianPricePerGpuHourUsd": 3.3263,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 2.7499,
            "medianPricePerGpuHourUsd": 2.8437,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 2.753,
            "medianPricePerGpuHourUsd": 2.9347,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 3.1797,
            "medianPricePerGpuHourUsd": 3.4507,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 2.9356,
            "medianPricePerGpuHourUsd": 3.3363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 3.6049,
            "medianPricePerGpuHourUsd": 3.9614,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 4.0844,
            "medianPricePerGpuHourUsd": 4.086,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 2.9344,
            "medianPricePerGpuHourUsd": 2.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 2.9339,
            "medianPricePerGpuHourUsd": 2.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 3.9987,
            "medianPricePerGpuHourUsd": 3.9987,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 4.4502,
            "medianPricePerGpuHourUsd": 4.4502,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 2.9356,
            "medianPricePerGpuHourUsd": 2.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 2.9304,
            "medianPricePerGpuHourUsd": 2.9304,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 2.8867,
            "medianPricePerGpuHourUsd": 3.6572,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 2.8867,
            "medianPricePerGpuHourUsd": 3.4942,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 2.8867,
            "medianPricePerGpuHourUsd": 2.9344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 2.9356,
            "medianPricePerGpuHourUsd": 3.7329,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 3.1437,
            "medianPricePerGpuHourUsd": 3.1437,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 2.3436,
            "medianPricePerGpuHourUsd": 3.4936,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          }
        ]
      },
      {
        "sku": "h100-sxm",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 1.3341,
            "medianPricePerGpuHourUsd": 1.537,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 1.3341,
            "medianPricePerGpuHourUsd": 1.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 1.3348,
            "medianPricePerGpuHourUsd": 1.6396,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.6342,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 1.2015,
            "medianPricePerGpuHourUsd": 1.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 1.5344,
            "medianPricePerGpuHourUsd": 1.8037,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 1.4672,
            "medianPricePerGpuHourUsd": 1.5363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 1.4681,
            "medianPricePerGpuHourUsd": 1.5851,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 1.5339,
            "medianPricePerGpuHourUsd": 1.6011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T01:49:52.058Z",
            "minPricePerGpuHourUsd": 1.4185,
            "medianPricePerGpuHourUsd": 1.8037,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 1.5339,
            "medianPricePerGpuHourUsd": 1.6827,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.6229,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 1.5356,
            "medianPricePerGpuHourUsd": 1.6739,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.9356,
            "medianPricePerGpuHourUsd": 1.7625,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.7748,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 1.4672,
            "medianPricePerGpuHourUsd": 1.8674,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 1.0672,
            "medianPricePerGpuHourUsd": 1.7687,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 1.0011,
            "medianPricePerGpuHourUsd": 1.9222,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.3348,
            "medianPricePerGpuHourUsd": 1.8689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.795,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 1.3348,
            "medianPricePerGpuHourUsd": 1.583,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 1.3348,
            "medianPricePerGpuHourUsd": 1.6699,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 1.5356,
            "medianPricePerGpuHourUsd": 1.7681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 1.5348,
            "medianPricePerGpuHourUsd": 1.9231,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 1.4148,
            "medianPricePerGpuHourUsd": 1.657,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 1.4689,
            "medianPricePerGpuHourUsd": 1.8674,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.7242,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 1.4672,
            "medianPricePerGpuHourUsd": 1.9284,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 1.4689,
            "medianPricePerGpuHourUsd": 1.6457,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 1.4672,
            "medianPricePerGpuHourUsd": 1.6017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.6462,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 1.5416,
            "medianPricePerGpuHourUsd": 1.8689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 1.5456,
            "medianPricePerGpuHourUsd": 1.7823,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 1.4244,
            "medianPricePerGpuHourUsd": 1.7022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 1.4689,
            "medianPricePerGpuHourUsd": 1.7807,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.6917,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 1.4689,
            "medianPricePerGpuHourUsd": 1.8678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.6011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 1.6678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 1.5434,
            "medianPricePerGpuHourUsd": 2.0673,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 1.4948,
            "medianPricePerGpuHourUsd": 1.555,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 1.4672,
            "medianPricePerGpuHourUsd": 1.5887,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.5537,
            "medianPricePerGpuHourUsd": 1.7823,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 1.537,
            "medianPricePerGpuHourUsd": 1.8358,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 1.4681,
            "medianPricePerGpuHourUsd": 1.6017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 1.4991,
            "medianPricePerGpuHourUsd": 1.6017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 1.4689,
            "medianPricePerGpuHourUsd": 1.6168,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 1.4672,
            "medianPricePerGpuHourUsd": 1.7342,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 1.5444,
            "medianPricePerGpuHourUsd": 1.7728,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 1.4991,
            "medianPricePerGpuHourUsd": 1.7501,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.9337,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 1.6324,
            "medianPricePerGpuHourUsd": 2.2931,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 2.2822,
            "medianPricePerGpuHourUsd": 4.1878,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 2.9344,
            "medianPricePerGpuHourUsd": 3.4138,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 2.9344,
            "medianPricePerGpuHourUsd": 4.1889,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 2.7215,
            "medianPricePerGpuHourUsd": 2.7348,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 5.2156,
            "medianPricePerGpuHourUsd": 5.2156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 6.0811,
            "medianPricePerGpuHourUsd": 6.0817,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 3.0689,
            "medianPricePerGpuHourUsd": 4.0017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 2.6407,
            "medianPricePerGpuHourUsd": 4.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 3.694,
            "medianPricePerGpuHourUsd": 4.335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 2.3341,
            "medianPricePerGpuHourUsd": 4.0003,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 2.3341,
            "medianPricePerGpuHourUsd": 3.694,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 2.3356,
            "medianPricePerGpuHourUsd": 3.6339,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 2.5962,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 2.6416,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 23
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 2.8011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 3.3756,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 3.2015,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 2.4007,
            "medianPricePerGpuHourUsd": 4.0404,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 2.6689,
            "medianPricePerGpuHourUsd": 4.375,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 2.4004,
            "medianPricePerGpuHourUsd": 4.135,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 3.6011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 22
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 3.4956,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 21
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 3.1078,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.6685,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.8003,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 2.402,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 2.5217,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 1.5344,
            "medianPricePerGpuHourUsd": 2.6675,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.6672,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 1.5344,
            "medianPricePerGpuHourUsd": 2.601,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 2.0022,
            "medianPricePerGpuHourUsd": 2.3756,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 2.2816,
            "medianPricePerGpuHourUsd": 2.6674,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 2.2541,
            "medianPricePerGpuHourUsd": 2.5308,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 2.2541,
            "medianPricePerGpuHourUsd": 2.4083,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 2.3335,
            "medianPricePerGpuHourUsd": 2.4013,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 2.1337,
            "medianPricePerGpuHourUsd": 2.1347,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 2.1348,
            "medianPricePerGpuHourUsd": 2.401,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 2.1356,
            "medianPricePerGpuHourUsd": 2.4006,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 2.0422,
            "medianPricePerGpuHourUsd": 2.3974,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 1.6111,
            "medianPricePerGpuHourUsd": 2.4004,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 2.3012,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 2.1341,
            "medianPricePerGpuHourUsd": 2.336,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 1.4678,
            "medianPricePerGpuHourUsd": 2.4003,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 2.136,
            "medianPricePerGpuHourUsd": 2.2348,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 2.3335,
            "medianPricePerGpuHourUsd": 2.4004,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 2.3335,
            "medianPricePerGpuHourUsd": 2.3335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 2.136,
            "medianPricePerGpuHourUsd": 2.2675,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 2.2678,
            "medianPricePerGpuHourUsd": 2.3335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 1.9219,
            "medianPricePerGpuHourUsd": 2.2016,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 2.2006,
            "medianPricePerGpuHourUsd": 2.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 2.2004,
            "medianPricePerGpuHourUsd": 2.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 2.2006,
            "medianPricePerGpuHourUsd": 2.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 2.2004,
            "medianPricePerGpuHourUsd": 2.2006,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 2.3335,
            "medianPricePerGpuHourUsd": 2.3335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 2.2011,
            "medianPricePerGpuHourUsd": 2.2535,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 2.268,
            "medianPricePerGpuHourUsd": 2.2687,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 2.2011,
            "medianPricePerGpuHourUsd": 2.2352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 2.268,
            "medianPricePerGpuHourUsd": 2.268,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 2.2011,
            "medianPricePerGpuHourUsd": 2.2352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 2.2004,
            "medianPricePerGpuHourUsd": 2.3271,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 2.2006,
            "medianPricePerGpuHourUsd": 2.2008,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 2.2006,
            "medianPricePerGpuHourUsd": 2.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 2.2011,
            "medianPricePerGpuHourUsd": 2.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-sxm",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-sxm",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.69,
            "medianPricePerGpuHourUsd": 2.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 3.29,
            "medianPricePerGpuHourUsd": 3.29,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 2.99,
            "medianPricePerGpuHourUsd": 2.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-nvl",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 1.5182,
            "medianPricePerGpuHourUsd": 1.6689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 1.3724,
            "medianPricePerGpuHourUsd": 2.2672,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 1.6019,
            "medianPricePerGpuHourUsd": 2.2017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 1.5142,
            "medianPricePerGpuHourUsd": 2.2683,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 1.5951,
            "medianPricePerGpuHourUsd": 2.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 2.1356,
            "medianPricePerGpuHourUsd": 2.6683,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 2.2689,
            "medianPricePerGpuHourUsd": 2.6678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 1.6019,
            "medianPricePerGpuHourUsd": 2.0822,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 1.7606,
            "medianPricePerGpuHourUsd": 2.0822,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T01:49:52.058Z",
            "minPricePerGpuHourUsd": 1.6019,
            "medianPricePerGpuHourUsd": 2.0689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 1.7606,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 1.5196,
            "medianPricePerGpuHourUsd": 1.8809,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 1.5182,
            "medianPricePerGpuHourUsd": 2.0013,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 1.7556,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 1.6963,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 1.6009,
            "medianPricePerGpuHourUsd": 1.9346,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 1.6022,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 1.8681,
            "medianPricePerGpuHourUsd": 2.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.8681,
            "medianPricePerGpuHourUsd": 2.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 2.9389,
            "medianPricePerGpuHourUsd": 2.9389,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 1.5622,
            "medianPricePerGpuHourUsd": 1.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 1.5889,
            "medianPricePerGpuHourUsd": 1.7285,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 1.5182,
            "medianPricePerGpuHourUsd": 1.6024,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 1.3356,
            "medianPricePerGpuHourUsd": 2.1372,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 1.5182,
            "medianPricePerGpuHourUsd": 2.0019,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 1.5956,
            "medianPricePerGpuHourUsd": 1.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 1.5142,
            "medianPricePerGpuHourUsd": 1.8678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 1.8674,
            "medianPricePerGpuHourUsd": 2.003,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 1.5556,
            "medianPricePerGpuHourUsd": 1.8674,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 1.6293,
            "medianPricePerGpuHourUsd": 1.6293,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 1.6293,
            "medianPricePerGpuHourUsd": 1.7613,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 1.5116,
            "medianPricePerGpuHourUsd": 1.7608,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 1.6293,
            "medianPricePerGpuHourUsd": 1.7613,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 1.5142,
            "medianPricePerGpuHourUsd": 1.6287,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 1.6022,
            "medianPricePerGpuHourUsd": 1.6887,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 1.6293,
            "medianPricePerGpuHourUsd": 1.8415,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 1.7356,
            "medianPricePerGpuHourUsd": 1.7356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 1.7748,
            "medianPricePerGpuHourUsd": 1.9552,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 1.8681,
            "medianPricePerGpuHourUsd": 1.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 1.8681,
            "medianPricePerGpuHourUsd": 1.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.8681,
            "medianPricePerGpuHourUsd": 1.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 1.5196,
            "medianPricePerGpuHourUsd": 1.6939,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 1.6304,
            "medianPricePerGpuHourUsd": 1.9888,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 2.9389,
            "medianPricePerGpuHourUsd": 2.9389,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 1.5956,
            "medianPricePerGpuHourUsd": 1.8156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 2.9361,
            "medianPricePerGpuHourUsd": 2.9375,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 1.6704,
            "medianPricePerGpuHourUsd": 1.6704,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T01:49:51.866Z",
            "minPricePerGpuHourUsd": 1.5142,
            "medianPricePerGpuHourUsd": 2.2266,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 2.0015,
            "medianPricePerGpuHourUsd": 2.9361,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 1.7622,
            "medianPricePerGpuHourUsd": 1.7622,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 1.7611,
            "medianPricePerGpuHourUsd": 1.7617,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 1.7611,
            "medianPricePerGpuHourUsd": 1.7617,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 1.7622,
            "medianPricePerGpuHourUsd": 1.7622,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 2.8156,
            "medianPricePerGpuHourUsd": 2.8156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 2.0044,
            "medianPricePerGpuHourUsd": 2.4567,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 2.9222,
            "medianPricePerGpuHourUsd": 2.9306,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 2.1378,
            "medianPricePerGpuHourUsd": 2.9225,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 1.7622,
            "medianPricePerGpuHourUsd": 2.1348,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 1.5209,
            "medianPricePerGpuHourUsd": 2.5707,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 2.9899,
            "medianPricePerGpuHourUsd": 2.9916,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 2.7665,
            "medianPricePerGpuHourUsd": 2.8056,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 2.0022,
            "medianPricePerGpuHourUsd": 2.4422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 2.4689,
            "medianPricePerGpuHourUsd": 2.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 2.5089,
            "medianPricePerGpuHourUsd": 2.651,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 2.0022,
            "medianPricePerGpuHourUsd": 2.5656,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 2.4015,
            "medianPricePerGpuHourUsd": 2.6377,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 2.5081,
            "medianPricePerGpuHourUsd": 2.6322,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 2.5422,
            "medianPricePerGpuHourUsd": 2.5422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 2.5356,
            "medianPricePerGpuHourUsd": 2.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 2.5422,
            "medianPricePerGpuHourUsd": 2.5589,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 2.1356,
            "medianPricePerGpuHourUsd": 2.5422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 2.3169,
            "medianPricePerGpuHourUsd": 2.4907,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 2.5756,
            "medianPricePerGpuHourUsd": 2.7932,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 2.403,
            "medianPricePerGpuHourUsd": 2.4059,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 2.6332,
            "medianPricePerGpuHourUsd": 2.6332,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 2.0015,
            "medianPricePerGpuHourUsd": 2.4059,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 2.4022,
            "medianPricePerGpuHourUsd": 2.7132,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 2.4011,
            "medianPricePerGpuHourUsd": 2.4292,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 2.0622,
            "medianPricePerGpuHourUsd": 2.5556,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 3.0007,
            "medianPricePerGpuHourUsd": 3.0007,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 2.0966,
            "medianPricePerGpuHourUsd": 2.0982,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 2.6681,
            "medianPricePerGpuHourUsd": 2.6681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 1.9556,
            "medianPricePerGpuHourUsd": 2.3248,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 2.0007,
            "medianPricePerGpuHourUsd": 2.2715,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 1.9753,
            "medianPricePerGpuHourUsd": 2.2689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 2.0089,
            "medianPricePerGpuHourUsd": 2.3078,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 2.2278,
            "medianPricePerGpuHourUsd": 2.2839,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 2.0022,
            "medianPricePerGpuHourUsd": 2.0044,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 2.6674,
            "medianPricePerGpuHourUsd": 2.6678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 2.1344,
            "medianPricePerGpuHourUsd": 2.6681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 1.9926,
            "medianPricePerGpuHourUsd": 2.0219,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 2.7499,
            "medianPricePerGpuHourUsd": 2.7516,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 1.9896,
            "medianPricePerGpuHourUsd": 1.9911,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 2.1339,
            "medianPricePerGpuHourUsd": 2.1344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 1.9926,
            "medianPricePerGpuHourUsd": 1.9926,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 2.1339,
            "medianPricePerGpuHourUsd": 2.1344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 2.1356,
            "medianPricePerGpuHourUsd": 2.1356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 2.0681,
            "medianPricePerGpuHourUsd": 2.1013,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 2.3489,
            "medianPricePerGpuHourUsd": 2.3489,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 2.1339,
            "medianPricePerGpuHourUsd": 2.1344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 2.3489,
            "medianPricePerGpuHourUsd": 2.3489,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 2.1033,
            "medianPricePerGpuHourUsd": 2.1065,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 2.5889,
            "medianPricePerGpuHourUsd": 2.5889,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 2.7083,
            "medianPricePerGpuHourUsd": 2.7099,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 2.0022,
            "medianPricePerGpuHourUsd": 2.0033,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 2.0022,
            "medianPricePerGpuHourUsd": 2.2662,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 2.2062,
            "medianPricePerGpuHourUsd": 2.2062,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-nvl",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 2.59,
            "medianPricePerGpuHourUsd": 2.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-nvl",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 3.07,
            "medianPricePerGpuHourUsd": 3.07,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 3.19,
            "medianPricePerGpuHourUsd": 3.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-pcie",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 1.3378,
            "medianPricePerGpuHourUsd": 1.3378,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 1.5356,
            "medianPricePerGpuHourUsd": 1.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 1.5356,
            "medianPricePerGpuHourUsd": 1.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 1.5356,
            "medianPricePerGpuHourUsd": 1.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.2044,
            "medianPricePerGpuHourUsd": 1.2044,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 1.5356,
            "medianPricePerGpuHourUsd": 1.7683,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 1.2044,
            "medianPricePerGpuHourUsd": 1.2044,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 2.6711,
            "medianPricePerGpuHourUsd": 2.6711,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 1.6037,
            "medianPricePerGpuHourUsd": 1.6037,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 2.2178,
            "medianPricePerGpuHourUsd": 2.2178,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 2.2178,
            "medianPricePerGpuHourUsd": 2.2178,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 2.7889,
            "medianPricePerGpuHourUsd": 2.7889,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 1.9778,
            "medianPricePerGpuHourUsd": 1.9778,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 1.9748,
            "medianPricePerGpuHourUsd": 2.3685,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 2.5222,
            "medianPricePerGpuHourUsd": 2.5222,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 2.5644,
            "medianPricePerGpuHourUsd": 2.5644,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 2.0006,
            "medianPricePerGpuHourUsd": 2.0008,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 2.2311,
            "medianPricePerGpuHourUsd": 2.2311,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 2.8156,
            "medianPricePerGpuHourUsd": 2.8156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 2.2711,
            "medianPricePerGpuHourUsd": 2.2711,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 2.3711,
            "medianPricePerGpuHourUsd": 2.3711,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 2.0011,
            "medianPricePerGpuHourUsd": 2.0011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 2.3911,
            "medianPricePerGpuHourUsd": 2.3911,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 2.1244,
            "medianPricePerGpuHourUsd": 2.2,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 1.8178,
            "medianPricePerGpuHourUsd": 1.8178,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 1.5978,
            "medianPricePerGpuHourUsd": 1.5978,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 1.5844,
            "medianPricePerGpuHourUsd": 1.5844,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 1.6422,
            "medianPricePerGpuHourUsd": 1.6422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 1.6422,
            "medianPricePerGpuHourUsd": 1.6422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 2.1335,
            "medianPricePerGpuHourUsd": 2.1335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 2.1335,
            "medianPricePerGpuHourUsd": 2.1335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 2.0001,
            "medianPricePerGpuHourUsd": 2.0001,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 1.8672,
            "medianPricePerGpuHourUsd": 1.8672,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 1.7356,
            "medianPricePerGpuHourUsd": 1.7356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-pcie",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 1.99,
            "medianPricePerGpuHourUsd": 1.99,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "h100-pcie",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 2.39,
            "medianPricePerGpuHourUsd": 2.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 2.89,
            "medianPricePerGpuHourUsd": 2.89,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "a100-sxm-80",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 0.6681,
            "medianPricePerGpuHourUsd": 1.1841,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 0.4278,
            "medianPricePerGpuHourUsd": 0.9889,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 0.6564,
            "medianPricePerGpuHourUsd": 0.9261,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 0.6139,
            "medianPricePerGpuHourUsd": 1.1244,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 0.4002,
            "medianPricePerGpuHourUsd": 0.8938,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 0.6139,
            "medianPricePerGpuHourUsd": 1.0909,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 0.6144,
            "medianPricePerGpuHourUsd": 0.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 1.0693,
            "medianPricePerGpuHourUsd": 1.0943,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 0.9356,
            "medianPricePerGpuHourUsd": 1.118,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T01:49:52.058Z",
            "minPricePerGpuHourUsd": 0.4002,
            "medianPricePerGpuHourUsd": 1.0102,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 0.5341,
            "medianPricePerGpuHourUsd": 1.0347,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 0.4278,
            "medianPricePerGpuHourUsd": 1.0291,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 0.5341,
            "medianPricePerGpuHourUsd": 0.8696,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.4689,
            "medianPricePerGpuHourUsd": 1.154,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 1.1061,
            "medianPricePerGpuHourUsd": 1.1398,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 0.5131,
            "medianPricePerGpuHourUsd": 1.092,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 0.5616,
            "medianPricePerGpuHourUsd": 1.1332,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 0.5338,
            "medianPricePerGpuHourUsd": 0.9622,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 0.5341,
            "medianPricePerGpuHourUsd": 0.5878,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 0.6144,
            "medianPricePerGpuHourUsd": 1.1068,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 0.6139,
            "medianPricePerGpuHourUsd": 1.093,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 0.9076,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 0.6139,
            "medianPricePerGpuHourUsd": 1.1158,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 0.9111,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 0.6019,
            "medianPricePerGpuHourUsd": 0.9706,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 0.8037,
            "medianPricePerGpuHourUsd": 1.2134,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 1.0548,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 0.4478,
            "medianPricePerGpuHourUsd": 0.6136,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 0.6136,
            "medianPricePerGpuHourUsd": 0.8336,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 0.6139,
            "medianPricePerGpuHourUsd": 0.6144,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 0.6136,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 0.6359,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 0.4202,
            "medianPricePerGpuHourUsd": 0.6156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 0.6144,
            "medianPricePerGpuHourUsd": 0.7656,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 0.4478,
            "medianPricePerGpuHourUsd": 0.6156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 0.4478,
            "medianPricePerGpuHourUsd": 0.6144,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 0.6156,
            "medianPricePerGpuHourUsd": 0.6681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 0.4478,
            "medianPricePerGpuHourUsd": 0.615,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 0.4478,
            "medianPricePerGpuHourUsd": 0.5317,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 0.2498,
            "medianPricePerGpuHourUsd": 0.6144,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 0.5616,
            "medianPricePerGpuHourUsd": 0.6266,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 1.0541,
            "medianPricePerGpuHourUsd": 1.0548,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 0.6156,
            "medianPricePerGpuHourUsd": 0.6156,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 0.6156,
            "medianPricePerGpuHourUsd": 0.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 0.6136,
            "medianPricePerGpuHourUsd": 0.615,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.8289,
            "medianPricePerGpuHourUsd": 0.8289,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 0.4478,
            "medianPricePerGpuHourUsd": 0.7919,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T01:49:52.039Z",
            "minPricePerGpuHourUsd": 0.6007,
            "medianPricePerGpuHourUsd": 0.8484,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 0.6007,
            "medianPricePerGpuHourUsd": 0.6007,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 0.5096,
            "medianPricePerGpuHourUsd": 1.0556,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 0.523,
            "medianPricePerGpuHourUsd": 1.1219,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 0.956,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 0.2831,
            "medianPricePerGpuHourUsd": 0.901,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 20
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 0.483,
            "medianPricePerGpuHourUsd": 0.8472,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 31
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.4573,
            "medianPricePerGpuHourUsd": 0.8284,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 26
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 1.1744,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 0.8417,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 22
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 0.6406,
            "medianPricePerGpuHourUsd": 1.0111,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 24
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T01:49:52.056Z",
            "minPricePerGpuHourUsd": 0.6681,
            "medianPricePerGpuHourUsd": 0.9615,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 1.0621,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T01:49:50.643Z",
            "minPricePerGpuHourUsd": 0.4611,
            "medianPricePerGpuHourUsd": 1.1756,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 0.9075,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 32
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 1.0778,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 0.8002,
            "medianPricePerGpuHourUsd": 1.0344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.1261,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.0548,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 0.7341,
            "medianPricePerGpuHourUsd": 1.0557,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 24
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 0.6037,
            "medianPricePerGpuHourUsd": 1.0333,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 28
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.0067,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 32
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.1344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 23
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.0056,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 39
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.2639,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 18
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 0.8491,
            "medianPricePerGpuHourUsd": 1.137,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 22
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 0.8437,
            "medianPricePerGpuHourUsd": 1.8735,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 0.6674,
            "medianPricePerGpuHourUsd": 1.2548,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 28
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 0.7341,
            "medianPricePerGpuHourUsd": 1.3228,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 23
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 0.7341,
            "medianPricePerGpuHourUsd": 1.0561,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 23
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 0.6685,
            "medianPricePerGpuHourUsd": 1.0672,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 29
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 0.6685,
            "medianPricePerGpuHourUsd": 1.1463,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 26
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 0.6011,
            "medianPricePerGpuHourUsd": 1.0681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 0.5352,
            "medianPricePerGpuHourUsd": 1.1747,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 24
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 0.6011,
            "medianPricePerGpuHourUsd": 1.1827,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 20
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.1564,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 0.7348,
            "medianPricePerGpuHourUsd": 1.1973,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 0.6011,
            "medianPricePerGpuHourUsd": 1.1299,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 0.6011,
            "medianPricePerGpuHourUsd": 1.092,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 0.7007,
            "medianPricePerGpuHourUsd": 1.055,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 0.7007,
            "medianPricePerGpuHourUsd": 1.0744,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 0.667,
            "medianPricePerGpuHourUsd": 1.121,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 1.0983,
            "medianPricePerGpuHourUsd": 1.099,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 1.0254,
            "medianPricePerGpuHourUsd": 1.1394,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 0.6674,
            "medianPricePerGpuHourUsd": 1.0856,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 1.0254,
            "medianPricePerGpuHourUsd": 1.1419,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 1.0246,
            "medianPricePerGpuHourUsd": 1.0826,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 0.2669,
            "medianPricePerGpuHourUsd": 0.6457,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 1.1394,
            "medianPricePerGpuHourUsd": 1.1394,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 1.0877,
            "medianPricePerGpuHourUsd": 1.0877,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 0.4973,
            "medianPricePerGpuHourUsd": 0.498,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 1.0457,
            "medianPricePerGpuHourUsd": 1.0457,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "a100-sxm-80",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 1,
            "medianPricePerGpuHourUsd": 1.195,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          }
        ]
      },
      {
        "sku": "a100-sxm-80",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 1.49,
            "medianPricePerGpuHourUsd": 1.49,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "a100-pcie-80",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 1.0689,
            "medianPricePerGpuHourUsd": 1.0689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.7885,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 0.74,
            "medianPricePerGpuHourUsd": 0.74,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 0.5215,
            "medianPricePerGpuHourUsd": 0.5215,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.2948,
            "medianPricePerGpuHourUsd": 0.2948,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 0.5215,
            "medianPricePerGpuHourUsd": 0.5215,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 0.2948,
            "medianPricePerGpuHourUsd": 0.4081,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 1.2022,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 1.2022,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.8552,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 0.5207,
            "medianPricePerGpuHourUsd": 0.5215,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.5215,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.5081,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 1.2022,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.8552,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 1.2022,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 1.2022,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.5881,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.8552,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 0.4649,
            "medianPricePerGpuHourUsd": 0.4649,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 1.2022,
            "medianPricePerGpuHourUsd": 1.2022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 0.7624,
            "medianPricePerGpuHourUsd": 0.7624,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 0.9356,
            "medianPricePerGpuHourUsd": 0.9356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 0.6978,
            "medianPricePerGpuHourUsd": 0.8015,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 0.8015,
            "medianPricePerGpuHourUsd": 0.8015,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 0.4096,
            "medianPricePerGpuHourUsd": 0.6056,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 0.4096,
            "medianPricePerGpuHourUsd": 0.5081,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.4096,
            "medianPricePerGpuHourUsd": 0.8552,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 0.5215,
            "medianPricePerGpuHourUsd": 0.6307,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 0.8022,
            "medianPricePerGpuHourUsd": 0.8022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T01:49:51.866Z",
            "minPricePerGpuHourUsd": 0.8022,
            "medianPricePerGpuHourUsd": 0.8022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 0.4048,
            "medianPricePerGpuHourUsd": 0.8059,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 0.5615,
            "medianPricePerGpuHourUsd": 1.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 0.4096,
            "medianPricePerGpuHourUsd": 1.0509,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 0.4048,
            "medianPricePerGpuHourUsd": 0.8019,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 0.4096,
            "medianPricePerGpuHourUsd": 0.8019,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 0.8019,
            "medianPricePerGpuHourUsd": 1.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.4024,
            "medianPricePerGpuHourUsd": 0.736,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 0.4691,
            "medianPricePerGpuHourUsd": 0.7353,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 14
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 0.6411,
            "medianPricePerGpuHourUsd": 0.892,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 0.8533,
            "medianPricePerGpuHourUsd": 1.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T01:49:52.056Z",
            "minPricePerGpuHourUsd": 0.8009,
            "medianPricePerGpuHourUsd": 1.1983,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 0.6011,
            "medianPricePerGpuHourUsd": 0.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T01:49:50.643Z",
            "minPricePerGpuHourUsd": 0.7593,
            "medianPricePerGpuHourUsd": 0.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 0.6678,
            "medianPricePerGpuHourUsd": 0.9583,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 0.8681,
            "medianPricePerGpuHourUsd": 1.108,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 0.6022,
            "medianPricePerGpuHourUsd": 0.9343,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 0.7747,
            "medianPricePerGpuHourUsd": 1.1048,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.8733,
            "medianPricePerGpuHourUsd": 1.0557,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 0.6944,
            "medianPricePerGpuHourUsd": 1.1017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 0.6678,
            "medianPricePerGpuHourUsd": 0.8717,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 0.6672,
            "medianPricePerGpuHourUsd": 1.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 0.8674,
            "medianPricePerGpuHourUsd": 0.8905,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 0.6022,
            "medianPricePerGpuHourUsd": 0.9043,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 0.6951,
            "medianPricePerGpuHourUsd": 1.3311,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 1.1013,
            "medianPricePerGpuHourUsd": 1.1783,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 1.2681,
            "medianPricePerGpuHourUsd": 1.4013,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 0.6951,
            "medianPricePerGpuHourUsd": 0.9504,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 16
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 0.6944,
            "medianPricePerGpuHourUsd": 0.8674,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 0.6696,
            "medianPricePerGpuHourUsd": 0.8414,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 0.5973,
            "medianPricePerGpuHourUsd": 0.8689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 15
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 0.8681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 9
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 0.8014,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 0.7155,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 13
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 0.563,
            "medianPricePerGpuHourUsd": 1.1481,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 0.8733,
            "medianPricePerGpuHourUsd": 1.2017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 1.0681,
            "medianPricePerGpuHourUsd": 1.2011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 0.8733,
            "medianPricePerGpuHourUsd": 0.8733,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 0.5356,
            "medianPricePerGpuHourUsd": 0.812,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 0.8329,
            "medianPricePerGpuHourUsd": 1.0704,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 0.8733,
            "medianPricePerGpuHourUsd": 0.8733,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 1.2681,
            "medianPricePerGpuHourUsd": 1.2681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 1.0011,
            "medianPricePerGpuHourUsd": 1.0017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 0.6741,
            "medianPricePerGpuHourUsd": 0.6741,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 0.4015,
            "medianPricePerGpuHourUsd": 0.7019,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 2
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 0.4015,
            "medianPricePerGpuHourUsd": 0.4015,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 1.2681,
            "medianPricePerGpuHourUsd": 1.2681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 1.0022,
            "medianPricePerGpuHourUsd": 1.0022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 0.4015,
            "medianPricePerGpuHourUsd": 0.4015,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "a100-pcie-80",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 1.19,
            "medianPricePerGpuHourUsd": 1.19,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "a100-pcie-80",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 1.39,
            "medianPricePerGpuHourUsd": 1.39,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "rtx-5090",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 0.2668,
            "medianPricePerGpuHourUsd": 0.4352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 131
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 0.2669,
            "medianPricePerGpuHourUsd": 0.4545,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 130
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 0.2669,
            "medianPricePerGpuHourUsd": 0.4944,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 123
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 0.2837,
            "medianPricePerGpuHourUsd": 0.467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 118
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 0.2837,
            "medianPricePerGpuHourUsd": 0.4656,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 113
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 0.2669,
            "medianPricePerGpuHourUsd": 0.4311,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 87
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 0.2936,
            "medianPricePerGpuHourUsd": 0.4222,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 89
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 0.2272,
            "medianPricePerGpuHourUsd": 0.4603,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 110
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 0.2952,
            "medianPricePerGpuHourUsd": 0.4274,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 113
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T01:49:52.058Z",
            "minPricePerGpuHourUsd": 0.3085,
            "medianPricePerGpuHourUsd": 0.467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 114
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 0.2625,
            "medianPricePerGpuHourUsd": 0.4536,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 99
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 0.2669,
            "medianPricePerGpuHourUsd": 0.4609,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 88
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 0.2944,
            "medianPricePerGpuHourUsd": 0.5341,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 92
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.2942,
            "medianPricePerGpuHourUsd": 0.467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 91
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.4443,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 86
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 0.2978,
            "medianPricePerGpuHourUsd": 0.4544,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 100
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 0.2944,
            "medianPricePerGpuHourUsd": 0.4241,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 106
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 0.3096,
            "medianPricePerGpuHourUsd": 0.5086,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 90
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.4534,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 85
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.4281,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 85
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.4681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 114
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 0.2944,
            "medianPricePerGpuHourUsd": 0.4948,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 118
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.4449,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 113
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 0.2674,
            "medianPricePerGpuHourUsd": 0.4544,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 120
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 0.2944,
            "medianPricePerGpuHourUsd": 0.4681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 120
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 0.2978,
            "medianPricePerGpuHourUsd": 0.4948,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 114
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 0.323,
            "medianPricePerGpuHourUsd": 0.5104,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 125
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 0.3096,
            "medianPricePerGpuHourUsd": 0.4938,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 123
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.5107,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 136
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 0.297,
            "medianPricePerGpuHourUsd": 0.5081,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 136
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.5096,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 142
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 0.2556,
            "medianPricePerGpuHourUsd": 0.4683,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 130
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 0.2956,
            "medianPricePerGpuHourUsd": 0.5072,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 127
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 0.2946,
            "medianPricePerGpuHourUsd": 0.5073,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 109
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 0.2813,
            "medianPricePerGpuHourUsd": 0.4678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 128
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 0.2651,
            "medianPricePerGpuHourUsd": 0.467,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 134
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 0.2806,
            "medianPricePerGpuHourUsd": 0.4422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 127
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.4566,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 124
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4672,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 141
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 0.2952,
            "medianPricePerGpuHourUsd": 0.4515,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 132
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 0.3096,
            "medianPricePerGpuHourUsd": 0.4546,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 122
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 0.2942,
            "medianPricePerGpuHourUsd": 0.4534,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 124
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 0.2826,
            "medianPricePerGpuHourUsd": 0.4232,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 115
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 0.2837,
            "medianPricePerGpuHourUsd": 0.4422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 121
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 0.2939,
            "medianPricePerGpuHourUsd": 0.4284,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 127
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 0.3204,
            "medianPricePerGpuHourUsd": 0.4719,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 113
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 0.2689,
            "medianPricePerGpuHourUsd": 0.5083,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 104
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.3078,
            "medianPricePerGpuHourUsd": 0.5359,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 74
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 0.3339,
            "medianPricePerGpuHourUsd": 0.5493,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 40
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T01:49:52.039Z",
            "minPricePerGpuHourUsd": 0.3078,
            "medianPricePerGpuHourUsd": 0.4584,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 131
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 0.3062,
            "medianPricePerGpuHourUsd": 0.5014,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 136
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T01:49:51.866Z",
            "minPricePerGpuHourUsd": 0.3248,
            "medianPricePerGpuHourUsd": 0.5292,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 132
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 0.3198,
            "medianPricePerGpuHourUsd": 0.5242,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 125
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 0.3111,
            "medianPricePerGpuHourUsd": 0.5789,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 133
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 0.2978,
            "medianPricePerGpuHourUsd": 0.6009,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 110
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.6004,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 101
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.6007,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 71
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 0.3089,
            "medianPricePerGpuHourUsd": 0.5346,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 41
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.5363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 43
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.6696,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 61
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.6681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 37
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.6619,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 44
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T01:49:52.056Z",
            "minPricePerGpuHourUsd": 0.3744,
            "medianPricePerGpuHourUsd": 0.8019,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 41
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 56
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T01:49:50.643Z",
            "minPricePerGpuHourUsd": 0.3171,
            "medianPricePerGpuHourUsd": 0.8322,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 0.4669,
            "medianPricePerGpuHourUsd": 1.6031,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 12
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 0.5929,
            "medianPricePerGpuHourUsd": 0.9363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 11
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 0.6681,
            "medianPricePerGpuHourUsd": 1.335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 0.9356,
            "medianPricePerGpuHourUsd": 2.0016,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 10
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.5878,
            "medianPricePerGpuHourUsd": 1.337,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 101
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 0.5216,
            "medianPricePerGpuHourUsd": 1.0956,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 91
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 0.6278,
            "medianPricePerGpuHourUsd": 0.9677,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 106
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 0.6048,
            "medianPricePerGpuHourUsd": 0.9198,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 91
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 0.5356,
            "medianPricePerGpuHourUsd": 0.9352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 89
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 0.6672,
            "medianPricePerGpuHourUsd": 0.9554,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 0.8278,
            "medianPricePerGpuHourUsd": 1.3348,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 19
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 1.0672,
            "medianPricePerGpuHourUsd": 1.8037,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 1.1739,
            "medianPricePerGpuHourUsd": 2.6172,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 28
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 0.9348,
            "medianPricePerGpuHourUsd": 1.4789,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 64
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 0.7381,
            "medianPricePerGpuHourUsd": 1.2044,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 81
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 0.8919,
            "medianPricePerGpuHourUsd": 1.0959,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 62
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 0.777,
            "medianPricePerGpuHourUsd": 1.0689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 66
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 0.7356,
            "medianPricePerGpuHourUsd": 0.9527,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 0.5211,
            "medianPricePerGpuHourUsd": 1.067,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 65
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 0.6156,
            "medianPricePerGpuHourUsd": 0.9089,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 77
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 0.5756,
            "medianPricePerGpuHourUsd": 0.8822,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 95
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 0.4003,
            "medianPricePerGpuHourUsd": 0.8675,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 118
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 0.4096,
            "medianPricePerGpuHourUsd": 0.788,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 106
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 0.4002,
            "medianPricePerGpuHourUsd": 0.7344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 114
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 0.3607,
            "medianPricePerGpuHourUsd": 0.6689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 123
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 0.3615,
            "medianPricePerGpuHourUsd": 0.6422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 121
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 0.3996,
            "medianPricePerGpuHourUsd": 0.603,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 133
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 0.307,
            "medianPricePerGpuHourUsd": 0.5446,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 131
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 0.2804,
            "medianPricePerGpuHourUsd": 0.561,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 129
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 0.4669,
            "medianPricePerGpuHourUsd": 0.6028,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 0.4019,
            "medianPricePerGpuHourUsd": 0.5011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 0.4711,
            "medianPricePerGpuHourUsd": 0.6678,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 0.4011,
            "medianPricePerGpuHourUsd": 0.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 127
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 0.4011,
            "medianPricePerGpuHourUsd": 0.577,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 117
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 0.3737,
            "medianPricePerGpuHourUsd": 0.5341,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 129
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 0.3737,
            "medianPricePerGpuHourUsd": 0.5335,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 127
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 0.4556,
            "medianPricePerGpuHourUsd": 0.5342,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 0.4691,
            "medianPricePerGpuHourUsd": 0.5691,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 0.4811,
            "medianPricePerGpuHourUsd": 0.5825,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 0.4681,
            "medianPricePerGpuHourUsd": 0.5617,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 0.4022,
            "medianPricePerGpuHourUsd": 0.5475,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 0.4444,
            "medianPricePerGpuHourUsd": 0.6539,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 0.4289,
            "medianPricePerGpuHourUsd": 0.5356,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 0.3607,
            "medianPricePerGpuHourUsd": 0.5731,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 0.3341,
            "medianPricePerGpuHourUsd": 0.5094,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 8
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 0.4711,
            "medianPricePerGpuHourUsd": 0.5344,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 0.3748,
            "medianPricePerGpuHourUsd": 0.5752,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 0.3481,
            "medianPricePerGpuHourUsd": 0.6693,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 0.5104,
            "medianPricePerGpuHourUsd": 0.6681,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 0.3485,
            "medianPricePerGpuHourUsd": 0.575,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 0.3504,
            "medianPricePerGpuHourUsd": 0.6675,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 0.3481,
            "medianPricePerGpuHourUsd": 0.5873,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 0.4729,
            "medianPricePerGpuHourUsd": 0.4859,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 0.4678,
            "medianPricePerGpuHourUsd": 0.5504,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 0.4813,
            "medianPricePerGpuHourUsd": 0.6539,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 0.3472,
            "medianPricePerGpuHourUsd": 0.4993,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 0.3341,
            "medianPricePerGpuHourUsd": 0.6406,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 0.3215,
            "medianPricePerGpuHourUsd": 0.6539,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          }
        ]
      },
      {
        "sku": "rtx-4090",
        "provider": "vast",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:06:53.323Z",
            "minPricePerGpuHourUsd": 0.2268,
            "medianPricePerGpuHourUsd": 0.3605,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 96
          },
          {
            "date": "2026-03-15",
            "capturedAt": "2026-03-15T16:22:48.483Z",
            "minPricePerGpuHourUsd": 0.2419,
            "medianPricePerGpuHourUsd": 0.3759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 93
          },
          {
            "date": "2026-03-16",
            "capturedAt": "2026-03-16T02:15:50.615Z",
            "minPricePerGpuHourUsd": 0.2678,
            "medianPricePerGpuHourUsd": 0.3507,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 90
          },
          {
            "date": "2026-03-17",
            "capturedAt": "2026-03-17T01:41:02.985Z",
            "minPricePerGpuHourUsd": 0.2015,
            "medianPricePerGpuHourUsd": 0.3483,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 88
          },
          {
            "date": "2026-03-18",
            "capturedAt": "2026-03-18T01:52:30.080Z",
            "minPricePerGpuHourUsd": 0.2268,
            "medianPricePerGpuHourUsd": 0.3526,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 97
          },
          {
            "date": "2026-03-19",
            "capturedAt": "2026-03-19T01:52:30.267Z",
            "minPricePerGpuHourUsd": 0.2268,
            "medianPricePerGpuHourUsd": 0.3699,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 86
          },
          {
            "date": "2026-03-20",
            "capturedAt": "2026-03-20T01:52:30.209Z",
            "minPricePerGpuHourUsd": 0.2556,
            "medianPricePerGpuHourUsd": 0.3769,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 100
          },
          {
            "date": "2026-03-21",
            "capturedAt": "2026-03-21T01:52:30.264Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3619,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 89
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T01:49:51.907Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.361,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 92
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T01:49:52.058Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3622,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 85
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T01:49:52.069Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.388,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 95
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T01:49:52.025Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3622,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 87
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T01:49:52.018Z",
            "minPricePerGpuHourUsd": 0.2267,
            "medianPricePerGpuHourUsd": 0.3756,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 87
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 94
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T01:49:51.877Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3953,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 99
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T01:49:52.026Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3493,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 96
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T01:49:51.850Z",
            "minPricePerGpuHourUsd": 0.2422,
            "medianPricePerGpuHourUsd": 0.3607,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 89
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T01:49:50.942Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4005,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 86
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T01:49:52.100Z",
            "minPricePerGpuHourUsd": 0.2007,
            "medianPricePerGpuHourUsd": 0.3616,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 92
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T01:49:51.930Z",
            "minPricePerGpuHourUsd": 0.2422,
            "medianPricePerGpuHourUsd": 0.3895,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 78
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T01:49:52.055Z",
            "minPricePerGpuHourUsd": 0.2437,
            "medianPricePerGpuHourUsd": 0.3732,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 84
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T01:49:52.008Z",
            "minPricePerGpuHourUsd": 0.2437,
            "medianPricePerGpuHourUsd": 0.3654,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T01:49:51.756Z",
            "minPricePerGpuHourUsd": 0.2407,
            "medianPricePerGpuHourUsd": 0.388,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 62
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T01:49:51.781Z",
            "minPricePerGpuHourUsd": 0.2422,
            "medianPricePerGpuHourUsd": 0.3893,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 87
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T01:49:51.965Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4008,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 73
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T01:49:52.028Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3989,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T01:49:51.992Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3496,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 92
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T01:49:51.709Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3539,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 86
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T01:49:52.049Z",
            "minPricePerGpuHourUsd": 0.2267,
            "medianPricePerGpuHourUsd": 0.372,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 74
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T01:49:51.918Z",
            "minPricePerGpuHourUsd": 0.2541,
            "medianPricePerGpuHourUsd": 0.3912,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T01:49:51.810Z",
            "minPricePerGpuHourUsd": 0.2411,
            "medianPricePerGpuHourUsd": 0.3756,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 72
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T01:49:52.103Z",
            "minPricePerGpuHourUsd": 0.2422,
            "medianPricePerGpuHourUsd": 0.3748,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 67
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T01:49:51.858Z",
            "minPricePerGpuHourUsd": 0.2489,
            "medianPricePerGpuHourUsd": 0.3759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 92
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T01:49:52.160Z",
            "minPricePerGpuHourUsd": 0.2407,
            "medianPricePerGpuHourUsd": 0.3712,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 86
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T01:49:51.984Z",
            "minPricePerGpuHourUsd": 0.2556,
            "medianPricePerGpuHourUsd": 0.3878,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 83
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T01:49:50.772Z",
            "minPricePerGpuHourUsd": 0.243,
            "medianPricePerGpuHourUsd": 0.3693,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 71
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T01:49:51.891Z",
            "minPricePerGpuHourUsd": 0.2281,
            "medianPricePerGpuHourUsd": 0.3798,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 83
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T01:49:51.905Z",
            "minPricePerGpuHourUsd": 0.2678,
            "medianPricePerGpuHourUsd": 0.3881,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 79
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T01:49:51.603Z",
            "minPricePerGpuHourUsd": 0.2407,
            "medianPricePerGpuHourUsd": 0.3885,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 72
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T01:49:52.000Z",
            "minPricePerGpuHourUsd": 0.2269,
            "medianPricePerGpuHourUsd": 0.3845,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 84
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T01:49:50.724Z",
            "minPricePerGpuHourUsd": 0.2407,
            "medianPricePerGpuHourUsd": 0.3744,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 76
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T01:49:51.883Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3543,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 75
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T01:49:52.100Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3489,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 81
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T01:49:52.871Z",
            "minPricePerGpuHourUsd": 0.2422,
            "medianPricePerGpuHourUsd": 0.3756,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 83
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T01:49:50.898Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.358,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 82
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T01:49:51.723Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3729,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 91
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T01:49:52.127Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3606,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 96
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.2006,
            "medianPricePerGpuHourUsd": 0.3748,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 119
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T01:49:52.010Z",
            "minPricePerGpuHourUsd": 0.2535,
            "medianPricePerGpuHourUsd": 0.3605,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 111
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T01:49:52.039Z",
            "minPricePerGpuHourUsd": 0.2541,
            "medianPricePerGpuHourUsd": 0.363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 87
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T01:49:50.984Z",
            "minPricePerGpuHourUsd": 0.243,
            "medianPricePerGpuHourUsd": 0.3611,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 89
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T01:49:51.866Z",
            "minPricePerGpuHourUsd": 0.2269,
            "medianPricePerGpuHourUsd": 0.3739,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 95
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T01:49:52.361Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4008,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 90
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T01:49:50.747Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4004,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 76
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T01:49:51.822Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 83
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T01:49:51.987Z",
            "minPricePerGpuHourUsd": 0.2537,
            "medianPricePerGpuHourUsd": 0.4022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 75
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T01:49:51.960Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.4017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 60
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T01:49:50.797Z",
            "minPricePerGpuHourUsd": 0.2537,
            "medianPricePerGpuHourUsd": 0.4006,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 54
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T01:49:51.766Z",
            "minPricePerGpuHourUsd": 0.2541,
            "medianPricePerGpuHourUsd": 0.4004,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T01:49:50.616Z",
            "minPricePerGpuHourUsd": 0.254,
            "medianPricePerGpuHourUsd": 0.4022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 49
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T01:49:51.724Z",
            "minPricePerGpuHourUsd": 0.2537,
            "medianPricePerGpuHourUsd": 0.403,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 55
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T01:49:50.652Z",
            "minPricePerGpuHourUsd": 0.2678,
            "medianPricePerGpuHourUsd": 0.4219,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 66
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T01:49:52.056Z",
            "minPricePerGpuHourUsd": 0.2809,
            "medianPricePerGpuHourUsd": 0.5348,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 52
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T01:49:51.229Z",
            "minPricePerGpuHourUsd": 0.3206,
            "medianPricePerGpuHourUsd": 0.5904,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 65
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T01:49:50.643Z",
            "minPricePerGpuHourUsd": 0.3219,
            "medianPricePerGpuHourUsd": 0.8013,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 35
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T01:49:51.628Z",
            "minPricePerGpuHourUsd": 0.2809,
            "medianPricePerGpuHourUsd": 0.6685,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 40
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T01:49:50.842Z",
            "minPricePerGpuHourUsd": 0.2809,
            "medianPricePerGpuHourUsd": 0.603,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 58
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T01:49:51.955Z",
            "minPricePerGpuHourUsd": 0.3206,
            "medianPricePerGpuHourUsd": 0.6015,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 63
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T01:49:50.522Z",
            "minPricePerGpuHourUsd": 0.4008,
            "medianPricePerGpuHourUsd": 0.8428,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 46
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T01:49:51.861Z",
            "minPricePerGpuHourUsd": 0.6681,
            "medianPricePerGpuHourUsd": 1.0074,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T01:49:50.597Z",
            "minPricePerGpuHourUsd": 0.6669,
            "medianPricePerGpuHourUsd": 0.9606,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 56
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T01:49:51.933Z",
            "minPricePerGpuHourUsd": 0.5081,
            "medianPricePerGpuHourUsd": 0.6696,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 46
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T01:49:52.030Z",
            "minPricePerGpuHourUsd": 0.3483,
            "medianPricePerGpuHourUsd": 0.6696,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 43
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T01:49:51.783Z",
            "minPricePerGpuHourUsd": 0.4,
            "medianPricePerGpuHourUsd": 0.6711,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 49
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T01:49:52.102Z",
            "minPricePerGpuHourUsd": 0.6672,
            "medianPricePerGpuHourUsd": 0.8528,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 50
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T01:49:50.887Z",
            "minPricePerGpuHourUsd": 0.74,
            "medianPricePerGpuHourUsd": 1.2007,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T01:49:50.982Z",
            "minPricePerGpuHourUsd": 1.0704,
            "medianPricePerGpuHourUsd": 1.2037,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 17
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T01:49:51.874Z",
            "minPricePerGpuHourUsd": 1.0741,
            "medianPricePerGpuHourUsd": 1.7378,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 25
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T01:49:51.066Z",
            "minPricePerGpuHourUsd": 0.6689,
            "medianPricePerGpuHourUsd": 1.1352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 86
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T01:49:52.975Z",
            "minPricePerGpuHourUsd": 0.6674,
            "medianPricePerGpuHourUsd": 0.9363,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 64
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T01:49:52.083Z",
            "minPricePerGpuHourUsd": 0.5333,
            "medianPricePerGpuHourUsd": 0.8548,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 81
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T01:49:52.027Z",
            "minPricePerGpuHourUsd": 0.535,
            "medianPricePerGpuHourUsd": 0.7074,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 61
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T01:49:51.811Z",
            "minPricePerGpuHourUsd": 0.4022,
            "medianPricePerGpuHourUsd": 0.6689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 53
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T01:49:52.169Z",
            "minPricePerGpuHourUsd": 0.5206,
            "medianPricePerGpuHourUsd": 0.6689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 92
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T01:49:52.129Z",
            "minPricePerGpuHourUsd": 0.4844,
            "medianPricePerGpuHourUsd": 0.6567,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 66
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T01:49:50.814Z",
            "minPricePerGpuHourUsd": 0.4008,
            "medianPricePerGpuHourUsd": 0.617,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 53
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T01:49:51.070Z",
            "minPricePerGpuHourUsd": 0.4008,
            "medianPricePerGpuHourUsd": 0.5491,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 54
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T01:49:52.421Z",
            "minPricePerGpuHourUsd": 0.362,
            "medianPricePerGpuHourUsd": 0.5,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 58
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T01:49:52.045Z",
            "minPricePerGpuHourUsd": 0.4004,
            "medianPricePerGpuHourUsd": 0.4696,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T01:49:52.183Z",
            "minPricePerGpuHourUsd": 0.2809,
            "medianPricePerGpuHourUsd": 0.47,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 54
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T01:49:52.484Z",
            "minPricePerGpuHourUsd": 0.3474,
            "medianPricePerGpuHourUsd": 0.4759,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 60
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T01:49:51.967Z",
            "minPricePerGpuHourUsd": 0.2809,
            "medianPricePerGpuHourUsd": 0.4422,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 57
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T01:49:51.005Z",
            "minPricePerGpuHourUsd": 0.3743,
            "medianPricePerGpuHourUsd": 0.4274,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 63
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T01:49:52.401Z",
            "minPricePerGpuHourUsd": 0.3378,
            "medianPricePerGpuHourUsd": 0.4159,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 54
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T01:49:51.653Z",
            "minPricePerGpuHourUsd": 0.3478,
            "medianPricePerGpuHourUsd": 0.3965,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T01:52:59.700Z",
            "minPricePerGpuHourUsd": 0.4017,
            "medianPricePerGpuHourUsd": 0.537,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T01:52:59.707Z",
            "minPricePerGpuHourUsd": 0.3744,
            "medianPricePerGpuHourUsd": 0.4411,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T01:53:00.222Z",
            "minPricePerGpuHourUsd": 0.3211,
            "medianPricePerGpuHourUsd": 0.4022,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 69
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T01:53:00.779Z",
            "minPricePerGpuHourUsd": 0.3356,
            "medianPricePerGpuHourUsd": 0.4017,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 77
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T01:52:59.855Z",
            "minPricePerGpuHourUsd": 0.3329,
            "medianPricePerGpuHourUsd": 0.4011,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 69
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T01:21:40.142Z",
            "minPricePerGpuHourUsd": 0.3483,
            "medianPricePerGpuHourUsd": 0.3889,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 68
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T01:21:37.413Z",
            "minPricePerGpuHourUsd": 0.3483,
            "medianPricePerGpuHourUsd": 0.4508,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T01:21:37.363Z",
            "minPricePerGpuHourUsd": 0.3619,
            "medianPricePerGpuHourUsd": 0.5352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T01:21:37.302Z",
            "minPricePerGpuHourUsd": 0.3547,
            "medianPricePerGpuHourUsd": 0.3911,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T01:18:27.356Z",
            "minPricePerGpuHourUsd": 0.3511,
            "medianPricePerGpuHourUsd": 0.5352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T01:51:14.804Z",
            "minPricePerGpuHourUsd": 0.3552,
            "medianPricePerGpuHourUsd": 0.4704,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T01:39:57.333Z",
            "minPricePerGpuHourUsd": 0.3511,
            "medianPricePerGpuHourUsd": 0.5407,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 3
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T01:39:57.351Z",
            "minPricePerGpuHourUsd": 0.3613,
            "medianPricePerGpuHourUsd": 0.3819,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T01:39:57.345Z",
            "minPricePerGpuHourUsd": 0.3637,
            "medianPricePerGpuHourUsd": 0.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T01:39:57.415Z",
            "minPricePerGpuHourUsd": 0.3378,
            "medianPricePerGpuHourUsd": 0.4352,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T01:39:57.405Z",
            "minPricePerGpuHourUsd": 0.4689,
            "medianPricePerGpuHourUsd": 0.5165,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T01:39:57.337Z",
            "minPricePerGpuHourUsd": 0.3904,
            "medianPricePerGpuHourUsd": 0.5619,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T01:39:57.369Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.3567,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T01:39:57.330Z",
            "minPricePerGpuHourUsd": 0.3511,
            "medianPricePerGpuHourUsd": 0.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T01:39:57.312Z",
            "minPricePerGpuHourUsd": 0.3378,
            "medianPricePerGpuHourUsd": 0.5619,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T01:39:57.382Z",
            "minPricePerGpuHourUsd": 0.3511,
            "medianPricePerGpuHourUsd": 0.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T01:29:20.471Z",
            "minPricePerGpuHourUsd": 0.2672,
            "medianPricePerGpuHourUsd": 0.3244,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T01:29:20.445Z",
            "minPricePerGpuHourUsd": 0.337,
            "medianPricePerGpuHourUsd": 0.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T01:30:30.902Z",
            "minPricePerGpuHourUsd": 0.3485,
            "medianPricePerGpuHourUsd": 0.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T01:16:54.318Z",
            "minPricePerGpuHourUsd": 0.3485,
            "medianPricePerGpuHourUsd": 0.4008,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 6
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T01:11:40.554Z",
            "minPricePerGpuHourUsd": 0.3485,
            "medianPricePerGpuHourUsd": 0.3878,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 7
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T01:18:54.368Z",
            "minPricePerGpuHourUsd": 0.3339,
            "medianPricePerGpuHourUsd": 0.4689,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 5
          },
          {
            "date": "2026-07-14",
            "capturedAt": "2026-07-14T01:18:54.406Z",
            "minPricePerGpuHourUsd": 0.3489,
            "medianPricePerGpuHourUsd": 0.4902,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 4
          }
        ]
      },
      {
        "sku": "rtx-4090",
        "provider": "runpod-community",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 0.34,
            "medianPricePerGpuHourUsd": 0.34,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      },
      {
        "sku": "rtx-4090",
        "provider": "runpod-secure",
        "points": [
          {
            "date": "2026-03-14",
            "capturedAt": "2026-03-14T18:07:37.630Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-22",
            "capturedAt": "2026-03-22T16:38:51.818Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-23",
            "capturedAt": "2026-03-23T16:38:51.811Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-24",
            "capturedAt": "2026-03-24T16:38:51.734Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-25",
            "capturedAt": "2026-03-25T16:38:51.667Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-26",
            "capturedAt": "2026-03-26T16:38:51.971Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-27",
            "capturedAt": "2026-03-27T16:38:51.997Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-28",
            "capturedAt": "2026-03-28T16:38:51.706Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-29",
            "capturedAt": "2026-03-29T16:38:51.770Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-30",
            "capturedAt": "2026-03-30T16:38:51.943Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-03-31",
            "capturedAt": "2026-03-31T16:38:52.915Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-01",
            "capturedAt": "2026-04-01T16:38:51.879Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-02",
            "capturedAt": "2026-04-02T16:38:51.966Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-03",
            "capturedAt": "2026-04-03T16:38:51.925Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-04",
            "capturedAt": "2026-04-04T16:38:51.970Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-05",
            "capturedAt": "2026-04-05T16:38:51.762Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-06",
            "capturedAt": "2026-04-06T16:38:52.242Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-07",
            "capturedAt": "2026-04-07T16:38:50.682Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-08",
            "capturedAt": "2026-04-08T16:38:52.173Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-09",
            "capturedAt": "2026-04-09T16:38:52.025Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-10",
            "capturedAt": "2026-04-10T16:38:52.027Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-11",
            "capturedAt": "2026-04-11T16:38:51.842Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-12",
            "capturedAt": "2026-04-12T16:38:51.784Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-13",
            "capturedAt": "2026-04-13T16:38:52.077Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-14",
            "capturedAt": "2026-04-14T16:38:51.886Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-15",
            "capturedAt": "2026-04-15T16:38:52.023Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-16",
            "capturedAt": "2026-04-16T16:38:52.305Z",
            "minPricePerGpuHourUsd": 0.59,
            "medianPricePerGpuHourUsd": 0.59,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-17",
            "capturedAt": "2026-04-17T16:38:52.030Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-18",
            "capturedAt": "2026-04-18T16:38:51.737Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-19",
            "capturedAt": "2026-04-19T16:38:51.733Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-20",
            "capturedAt": "2026-04-20T16:38:52.052Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-21",
            "capturedAt": "2026-04-21T16:38:52.013Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-22",
            "capturedAt": "2026-04-22T16:38:51.997Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-23",
            "capturedAt": "2026-04-23T16:38:50.799Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-24",
            "capturedAt": "2026-04-24T16:38:50.985Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-25",
            "capturedAt": "2026-04-25T16:38:50.709Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-26",
            "capturedAt": "2026-04-26T16:38:51.802Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-27",
            "capturedAt": "2026-04-27T16:38:50.670Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-28",
            "capturedAt": "2026-04-28T16:38:52.259Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-29",
            "capturedAt": "2026-04-29T16:38:51.980Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-04-30",
            "capturedAt": "2026-04-30T16:38:50.631Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-01",
            "capturedAt": "2026-05-01T16:38:50.617Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-02",
            "capturedAt": "2026-05-02T16:38:51.853Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-03",
            "capturedAt": "2026-05-03T16:38:51.701Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-04",
            "capturedAt": "2026-05-04T16:38:51.908Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-05",
            "capturedAt": "2026-05-05T16:38:52.086Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-06",
            "capturedAt": "2026-05-06T16:38:50.657Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-07",
            "capturedAt": "2026-05-07T16:38:51.978Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-08",
            "capturedAt": "2026-05-08T16:38:51.967Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-09",
            "capturedAt": "2026-05-09T16:38:51.767Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-10",
            "capturedAt": "2026-05-10T16:38:51.753Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-11",
            "capturedAt": "2026-05-11T16:38:51.925Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-12",
            "capturedAt": "2026-05-12T16:38:50.762Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-13",
            "capturedAt": "2026-05-13T16:38:51.919Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-14",
            "capturedAt": "2026-05-14T16:38:50.617Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-15",
            "capturedAt": "2026-05-15T16:38:52.449Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-16",
            "capturedAt": "2026-05-16T16:38:51.842Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-17",
            "capturedAt": "2026-05-17T16:38:51.770Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-18",
            "capturedAt": "2026-05-18T16:38:52.128Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-19",
            "capturedAt": "2026-05-19T16:38:51.926Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-20",
            "capturedAt": "2026-05-20T16:38:52.050Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-21",
            "capturedAt": "2026-05-21T16:38:51.984Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-22",
            "capturedAt": "2026-05-22T16:38:51.762Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-23",
            "capturedAt": "2026-05-23T16:38:51.878Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-24",
            "capturedAt": "2026-05-24T16:38:51.816Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-25",
            "capturedAt": "2026-05-25T16:38:51.868Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-26",
            "capturedAt": "2026-05-26T16:38:52.008Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-27",
            "capturedAt": "2026-05-27T16:38:51.738Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-28",
            "capturedAt": "2026-05-28T16:38:51.745Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-29",
            "capturedAt": "2026-05-29T16:38:51.863Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-30",
            "capturedAt": "2026-05-30T16:38:52.048Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-05-31",
            "capturedAt": "2026-05-31T16:38:51.917Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-01",
            "capturedAt": "2026-06-01T16:38:50.788Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-02",
            "capturedAt": "2026-06-02T16:38:51.744Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-03",
            "capturedAt": "2026-06-03T16:38:51.983Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-04",
            "capturedAt": "2026-06-04T16:38:50.622Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-05",
            "capturedAt": "2026-06-05T16:38:51.980Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-06",
            "capturedAt": "2026-06-06T16:38:50.682Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-07",
            "capturedAt": "2026-06-07T16:38:51.927Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-08",
            "capturedAt": "2026-06-08T16:38:52.053Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-09",
            "capturedAt": "2026-06-09T16:38:52.051Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-10",
            "capturedAt": "2026-06-10T16:38:52.186Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-11",
            "capturedAt": "2026-06-11T16:38:50.587Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-12",
            "capturedAt": "2026-06-12T16:38:50.649Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-13",
            "capturedAt": "2026-06-13T16:38:51.656Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-14",
            "capturedAt": "2026-06-14T16:38:51.717Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-15",
            "capturedAt": "2026-06-15T16:38:50.564Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-16",
            "capturedAt": "2026-06-16T16:38:52.042Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-17",
            "capturedAt": "2026-06-17T16:05:42.651Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-18",
            "capturedAt": "2026-06-18T16:05:42.562Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-19",
            "capturedAt": "2026-06-19T16:05:43.887Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-20",
            "capturedAt": "2026-06-20T16:05:43.813Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-21",
            "capturedAt": "2026-06-21T16:32:21.828Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-22",
            "capturedAt": "2026-06-22T16:31:06.134Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-23",
            "capturedAt": "2026-06-23T16:31:06.111Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-24",
            "capturedAt": "2026-06-24T16:31:04.449Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-25",
            "capturedAt": "2026-06-25T16:31:04.510Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-26",
            "capturedAt": "2026-06-26T16:37:48.699Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-27",
            "capturedAt": "2026-06-27T16:12:01.432Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-28",
            "capturedAt": "2026-06-28T16:03:44.826Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-29",
            "capturedAt": "2026-06-29T16:03:43.619Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-06-30",
            "capturedAt": "2026-06-30T16:03:43.560Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-01",
            "capturedAt": "2026-07-01T16:03:45.022Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-02",
            "capturedAt": "2026-07-02T16:03:45.043Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-03",
            "capturedAt": "2026-07-03T16:03:43.534Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-04",
            "capturedAt": "2026-07-04T16:03:43.394Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-05",
            "capturedAt": "2026-07-05T16:03:43.478Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-06",
            "capturedAt": "2026-07-06T16:03:43.529Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-07",
            "capturedAt": "2026-07-07T16:03:45.081Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-08",
            "capturedAt": "2026-07-08T16:25:33.539Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-09",
            "capturedAt": "2026-07-09T16:25:33.469Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-10",
            "capturedAt": "2026-07-10T16:40:59.522Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-11",
            "capturedAt": "2026-07-11T16:40:59.462Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-12",
            "capturedAt": "2026-07-12T16:13:27.503Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          },
          {
            "date": "2026-07-13",
            "capturedAt": "2026-07-13T16:13:27.561Z",
            "minPricePerGpuHourUsd": 0.69,
            "medianPricePerGpuHourUsd": 0.69,
            "maxPricePerGpuHourUsd": null,
            "offerCount": 1
          }
        ]
      }
    ]
  },
  "methodology": [
    "Vast: verified, rentable, non-rented on-demand offers with reliability >= 95%; dph_total is divided by listed GPU count.",
    "RunPod: one-GPU lowest uninterruptable price, split into Community and Secure Cloud; null means no quoted stock.",
    "Azure CPU: East US Linux pay-as-you-go Virtual Machines only; Spot, Low Priority, Windows, and Cloud Services meters are excluded.",
    "GPU price history: getflops.ai dated collector snapshots, normalized to USD per GPU-hour and kept separate by provider and pricing type; current direct API snapshots overwrite the same calendar date in the chart.",
    "Daily snapshots are keyed by calendar date in R2; a same-day rerun replaces that day's observation instead of duplicating it."
  ],
  "limitations": [
    "Vast is a marketplace distribution while RunPod is a platform lowest price; compare the spread, do not average them into one market price.",
    "Vast bundled $/effective-vCPU-hour includes the GPU and system, so it is not a standalone CPU rental price.",
    "Azure D/E-series prices are a fixed public-cloud benchmark, not a market-wide CPU average; region, commitment term, and architecture can change realized cost.",
    "Listed supply and stock labels are availability signals, not utilization, contracted capacity, or guaranteed provisionability.",
    "Historical trends begin with collected R2 snapshots; neither provider exposes a complete point-in-time price history in these endpoints.",
    "Getflops history begins in March 2026 and is a third-party normalized collector, not a vendor billing record; attribution remains visible in the UI."
  ]
}
